'use strict';

(function (Account, $) {
  'use strict';

  var $form = void 0;
  var $passwordRecovery = void 0;

  var cacheDom = function cacheDom() {
    $form = $('#toggle-password-form');
    $passwordRecovery = $('.password-recovery');
  };

  var bindUIActions = function bindUIActions() {
    $form.on('click', function () {
      $passwordRecovery.slideToggle(200);
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  Account.init = init;
})(window.Account = window.Account || {}, jQuery);
'use strict';

(function (AddTax, $) {
  'use strict';

  var regexp = /[0-9]/;

  var countryCode = void 0;
  var appUrl = void 0;
  var taxRate = void 0;
  var $priceElements = void 0;
  var $orgySleevePrice = void 0;
  var $byoItemPrice = void 0;
  var $girlItemPrice = void 0;

  var GeolizerApiInit = false;

  var pollForGeolizerApi = setInterval(function () {
    if (window.GeolizrAPI && window.GeolizrAPI.hasOwnProperty('api')) {
      GeolizerApiInit = true;
      clearInterval(pollForGeolizerApi);
    }
  }, 1000);

  var cacheDom = function cacheDom() {
    $priceElements = $('[data-geolizr-price]').not('.cart-sidecar [data-geolizr-price]');
    $orgySleevePrice = $('[data-orgy-sleeve-price]');
    $byoItemPrice = $('[data-price-in-data]');
    $girlItemPrice = $('.js-girl-product-input');
    return true;
  };

  var setOptions = function setOptions(userOptions) {
    countryCode = userOptions.countryCode;
    appUrl = userOptions.appUrl;
  };

  var convertPrice = function convertPrice(originalPrice, taxRate) {
    var price = parseFloat(originalPrice.toFixed(2));
    return price * taxRate + price;
  };

  var setPrice = function setPrice($element, attr) {
    if ($element.length > 0) {
      $element.each(function setElementPrice() {
        var $this = $(this);
        var priceString = $this.attr(attr);
        var priceAdjustedString = void 0;
        var originalPrice = void 0;
        if (!isNaN(parseFloat(priceString))) {
          originalPrice = parseFloat(priceString);
        } else {
          /**
            * This line slices priceString from the first occurrence of a number
            * to the end of the string. This is to remove money symbols inserted
            * at the beginning of the string by Shopify.
            */
          priceAdjustedString = priceString.slice(priceString.search(regexp), priceString.length);
          originalPrice = parseFloat(priceAdjustedString);
        }
        var newPrice = convertPrice(originalPrice, taxRate);
        $this.attr(attr, newPrice);
      });
      return true;
    }
    return false;
  };

  var run = function run() {
    $.ajax({
      method: 'GET',
      url: appUrl,
      dataType: 'json',

      success: function success(countries) {
        var country = void 0;

        GeolizrAPI.addEventListener('currency.change', function (currency) {
          $('[data-geolizr-price]').css('opacity', '1');
        });

        // Figures out which country to get the tax rate from
        for (var i = 0; i < countries.countries.length; i++) {
          if (countries.countries[i].code.toLowerCase() === countryCode.toLowerCase() || countries.countries[i].code === '*') {
            country = countries.countries[i];
            break;
          }
        }
        if (country) {
          setTaxRate(country.tax);
        } else {
          setTaxRate(0);
        }
        setPrice($priceElements, 'data-geolizr-price');
        if (GeolizerApiInit) {
          window.GeolizrAPI.api.switchCurrency(window.GeolizrAPI.api.getCurrency());
        }
        window.Orgy.clickBinds();
        setPrice($orgySleevePrice, 'data-orgy-sleeve-price');
        setPrice($byoItemPrice, 'data-price');
        setPrice($girlItemPrice, 'data-price');
      },

      error: function error(jqXHR, textStatus, errorString) {
        var err = new Error(errorString);
        throw err;
      }
    });

    return true;
  };

  var setTaxRate = function setTaxRate(rate) {
    taxRate = rate;
    return taxRate;
  };

  // Calculates a new price based on the passed in price and the global tax rate
  var calculate = function calculate(price, rate) {
    if (rate) {
      taxRate = rate;
    }

    var stringPrice = (price + price * taxRate).toString();
    var index = stringPrice.indexOf('.');
    if (index >= 0) {
      stringPrice = stringPrice.slice(0, index + 3);
    }
    return parseFloat(stringPrice);
  };

  var getCountryCode = function getCountryCode() {
    return countryCode;
  };

  var getTaxRate = function getTaxRate() {
    return taxRate;
  };

  var init = function init(userOptions) {
    setOptions(userOptions);
    if (countryCode) {
      cacheDom();
      run();
      return true;
    }
    return false;
  };

  // REVEALS PUBLIC METHODS

  AddTax.calculate = calculate;
  AddTax.getCountryCode = getCountryCode;
  AddTax.getTaxRate = getTaxRate;
  AddTax.setPrice = setPrice;
  AddTax.init = init;
})(window.AddTax = window.AddTax || {}, jQuery);
'use strict';

(function (Alert, $) {
  'use strict';

  var $alert = void 0;

  var cacheDom = function cacheDom() {
    $alert = $('.alert-message');
  };

  var showAlert = function showAlert() {
    $alert.show().delay(2000).fadeOut('slow');
  };

  var checkFormSubmissionParameter = function checkFormSubmissionParameter() {
    if (window.location.search.indexOf('formSubmitted=true') !== -1) {
      showAlert();
    }
  };

  var init = function init() {
    cacheDom();
    checkFormSubmissionParameter();
  };

  Alert.init = init;
  Alert.showAlert = showAlert;
})(window.Alert = window.Alert || {}, jQuery);
'use strict';

(function (BackInStock, $) {
  'use strict';

  var emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  var $open = void 0;
  var $email = void 0;
  var $submit = void 0;
  var $messages = void 0;
  var $success = void 0;
  var $error = void 0;

  var cacheDom = function cacheDom() {
    $open = $('.js-bis-open');
    $email = $('.js-bis-email');
    $submit = $('.js-bis-submit');
    $messages = $('.js-bis-messages');
    $success = $messages.find('.js-bis-success');
    $error = $messages.find('.js-bis-error');
  };

  var setupForm = function setupForm(variantId, productId) {
    $submit.attr('data-variant-id', variantId).attr('data-product-id', productId);
  };

  var validate = function validate(inputEmail) {
    if (emailRegexp.test(inputEmail)) {
      return inputEmail;
    }

    return false;
  };

  var bindUIActions = function bindUIActions() {
    $open.on('click', function buttonClick(event) {
      event.preventDefault();

      var $this = $(this);
      var variantId = $this.data('variant-id');
      var productId = $this.data('product-id');

      setupForm(variantId, productId);
      $email.show();
      $submit.show();
      $success.hide();
      $error.hide();
    });

    $submit.on('click', function submit() {
      event.preventDefault();

      var $this = $(this);
      var variantId = $this.data('variant-id');
      var productId = $this.data('product-id');
      var email = validate($email.val());

      var success = false;

      if (email && variantId && productId) {
        window.BIS.create(email, variantId, productId).then(function (response) {
          if (response.status === 'OK') {
            success = true;
            $submit.hide();
            $email.hide();
            $error.hide();
            $success.show();
          } else {
            success = false;
            $error.show();
          }
        });
        return success;
      }

      $error.show();
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  BackInStock.init = init;
})(window.BackInStock = window.BackInStock || {}, jQuery);
'use strict';

(function (Buy2, $) {
  'use strict';

  var $columnContainer = void 0;
  var $swatch = void 0;
  var $sleeve = void 0;
  var $sleeveImg = void 0;
  var collectionHandle = void 0;

  var cacheDom = function cacheDom() {
    $columnContainer = $('.buy-2-columns');
    $swatch = $columnContainer.find('.swatch');
    $sleeve = $columnContainer.find('.sleeve');
    $sleeveImg = $sleeve.find('img');
  };

  var variableSetup = function variableSetup(options) {
    collectionHandle = options.collectionHandle;
  };

  var variantAddToCart = function variantAddToCart(variantArray, $this) {
    if ($.inArray(undefined, variantArray) !== -1 || $.inArray('', variantArray) !== -1) {
      alert('Select 3 sleeves to add to cart.');
      variantArray = [];
    } else {
      $this.text('ADDING');
      variantArray.forEach(function (id) {
        window.CartJS.addItem(id, 1);
      });
      variantArray = [];

      if (window.Cookies.get('BVAUpsell')) {
        window.InlineCart.triggerInlineCart();
        window.Scroll.lock();
      } else {
        var title = $this.attr('data-product-upsell-title');
        var $upsellTitle = $('.js-product-upsell-title');

        if (title) {
          $upsellTitle.text(title);
        } else {
          $upsellTitle.text(window.ProductUpsell.defaultTitle);
        }

        ProductUpsell.open(collectionHandle);
      }
    }
    return variantArray;
  };

  var bindUIActions = function bindUIActions() {
    var variantArray = [];

    // Desktop functionality
    $swatch.on('click', function switchActiveSwatch() {
      var $this = $(this);
      var activeClass = 'active';

      $this.parent().find('.' + activeClass).removeClass(activeClass);
      $this.addClass(activeClass);
    });

    $sleeveImg.on('click', function selectSleeve() {
      var $this = $(this);
      var $currentOrifice = $this.closest('.sleeve');
      var $activeOrifice = $this.closest('.sleeves').siblings('.sleeve-orifice-swatch').find('.active');
      var activeClass = 'sleeve-active';

      var newOrificeImg = void 0;
      var orificeVariant = void 0;

      if ($activeOrifice.hasClass('orifice-vag')) {
        newOrificeImg = $this.data('vag');
        orificeVariant = $this.data('vag-id');
      } else if ($activeOrifice.hasClass('orifice-butt')) {
        newOrificeImg = $this.data('butt');
        orificeVariant = $this.data('butt-id');
      } else if ($activeOrifice.hasClass('orifice-cheeks')) {
        newOrificeImg = $this.data('cheeks');
        orificeVariant = $this.data('cheeks-id');
      } else if ($activeOrifice.hasClass('orifice-mouth')) {
        newOrificeImg = $this.data('mouth');
        orificeVariant = $this.data('mouth-id');
      }

      if (newOrificeImg && orificeVariant) {
        $this.closest('.sleeves').siblings('.sleeve-image').find('img').attr('src', newOrificeImg);
        $this.closest('.sleeves').siblings('.sleeve-image').find('img').attr('data-variant-id', orificeVariant);
        $currentOrifice.siblings().removeClass(activeClass);
        $currentOrifice.addClass(activeClass);
      } else {
        alert('Select an orifice to continue.');
      }
    });

    $('.add-sleeves').on('click', function addSleeve() {
      $('.sleeve-image img').each(function addVariantToArray() {
        variantArray.push($(this).data('variant-id'));
      });

      variantArray = variantAddToCart(variantArray, $(this));

      $(document).on('cart.requestComplete', function () {
        $('.add-sleeves').text('ADD TO CART');
      });
    });

    // Mobile Functionality
    $('.mobile-swatch').on('click', function switchActiveSwatchMobile() {
      var $this = $(this);
      var swatchSectionIndex = $this.closest('.mobile-sleeve-section').attr('id');

      if ($this.parent().children().hasClass('active')) {
        $this.parent().find('.active').removeClass('active');
        $this.parent().siblings('.mobile-sleeves').find('.mobile-sleeve').removeClass('fade').slideDown('fast');
        $this.parent().siblings('.mobile-sleeves').find('.selected').removeClass('selected');
        $('.mobile-sleeve-image-' + swatchSectionIndex + ' img').attr('data-variant-id', '');
      } else {
        $this.addClass('active');
      }
    });

    $('.mobile-sleeve').on('click', function switchActiveSleeveMobile() {
      var $this = $(this);
      var mobileOrifice = $this.closest('.mobile-sleeve-section').find('.sleeve-orifice-swatch').children();
      var mobileOrificeActive = $this.closest('.mobile-sleeve-section').find('.sleeve-orifice-swatch').find('.active');
      var mobileOrificeSection = $this.closest('.mobile-sleeve-section').attr('id');

      var mobileImgURL = void 0;
      var mobileVariantId = void 0;

      if (!mobileOrifice.hasClass('active')) {
        alert('Select an orifice to continue.');
      } else {
        $('.mobile-sleeve-images').css('visibility', 'visible');

        if (mobileOrificeActive.hasClass('orifice-vag')) {
          mobileImgURL = $this.find('.sleeve-row-image').data('vag');
          mobileVariantId = $this.find('.sleeve-row-image').data('vag-id');
        } else if (mobileOrificeActive.hasClass('orifice-butt')) {
          mobileImgURL = $this.find('.sleeve-row-image').data('butt');
          mobileVariantId = $this.find('.sleeve-row-image').data('butt-id');
        } else if (mobileOrificeActive.hasClass('orifice-mouth')) {
          mobileImgURL = $this.find('.sleeve-row-image').data('mouth');
          mobileVariantId = $this.find('.sleeve-row-image').data('mouth-id');
        } else if (mobileOrificeActive.hasClass('orifice-cheeks')) {
          mobileImgURL = $this.find('.sleeve-row-image').data('cheeks');
          mobileVariantId = $this.find('.sleeve-row-image').data('cheeks-id');
        }

        $this.closest('.buy-2-grid-mobile').find('.mobile-sleeve-images').find('.mobile-sleeve-image-' + mobileOrificeSection).find('img').css('visibility', 'visible').attr('src', mobileImgURL).attr('data-variant-id', mobileVariantId);
      }
    });

    $('.sleeve-table-row').on('click', function selectSleeveMobile() {
      var $this = $(this);

      if ($this.hasClass('mobile-sleeve')) {
        if ($this.closest('.mobile-sleeve-section').find('.sleeve-orifice-swatch').children().hasClass('active')) {
          $this.siblings().slideToggle('fast').toggleClass('fade');
          if (!$this.hasClass('selected')) {
            $this.addClass('selected');
          } else {
            $this.removeClass('selected');
            var mobileSleeveSection = $(this).closest('.mobile-sleeve-section').attr('id');
            $this.closest('.buy-2-grid-mobile').find('.mobile-sleeve-images').find('.mobile-sleeve-image-' + mobileSleeveSection).find('img').attr('data-variant-id', '');
          }
        }
      } else {
        $this.siblings().slideToggle('fast').toggleClass('fade');
      }
    });

    $('.add-sleeves-mobile').on('click', function addSleeveMobile() {
      $('.mobile-sleeve-image img').each(function addVariantToArrayMobile() {
        variantArray.push($(this).data('variant-id'));
      });

      variantArray = variantAddToCart(variantArray, $(this));

      $(document).on('cart.requestComplete', function () {
        $('.add-sleeves-mobile').text('ADD TO CART');
      });
    });
  };

  var init = function init(options) {
    cacheDom();
    variableSetup(options);
    bindUIActions();
  };

  Buy2.init = init;
})(window.Buy2 = window.Buy2 || {}, jQuery);
'use strict';

(function (CollectionBanner, $) {
  'use strict';

  var hidden = 'collection-banner-item--hidden';

  var $bannerContainer = void 0;
  var $video = void 0;
  var $image = void 0;

  var cacheDom = function cacheDom() {
    $bannerContainer = $('.js-collection-banner');
    $video = $bannerContainer.find('.js-collection-banner-video');
    $image = $bannerContainer.find('.js-collection-banner-image');
  };

  var setInitialState = function setInitialState() {
    if ($(window).width() > 991) {
      $(document).on('ready', function () {
        $video[0].play();
      });
    } else {
      $video.addClass(hidden);
      $image.removeClass(hidden);
    }
  };

  var bindUIActions = function bindUIActions() {
    $(window).on('resize', function () {
      var width = $(this).width();

      if (width > 991) {
        $video.removeClass(hidden);
        if ($video[0].paused) {
          $video[0].play();
        }
      } else {
        $video.addClass(hidden);
        if (!$video[0].paused) {
          $video[0].pause();
        }
      }
    });
  };

  var init = function init() {
    cacheDom();
    if ($video[0]) {
      setInitialState();
      bindUIActions();
    }
  };

  CollectionBanner.init = init;
})(window.CollectionBanner = window.CollectionBanner || {}, jQuery);
'use strict';

(function (CollectionsDisplay, $) {
  'use strict';

  var hiddenClass = "collections-display-row-hidden";

  var $container = void 0;
  var $load = void 0;
  var $row = void 0;
  var index = 2;

  var cacheDom = function cacheDom() {
    $container = $('.js-collections-display');
    $load = $container.find('.js-collections-display-load');
    $row = $container.find('.js-collecitons-display-row');
  };

  var iterate = function iterate() {
    index += 1;
    return index;
  };

  var showMore = function showMore($this) {
    var hasNextIndex = false;
    var found = false;
    $row.each(function () {
      var $this = $(this);
      if (!found && $this.attr('data-index') === index.toString()) {
        $this.removeClass(hiddenClass);
        found = true;
      }
    });

    iterate();

    if (parseInt($row.last().attr('data-index')) < index) {
      hasNextIndex = true;
    }

    if (hasNextIndex === true) {
      $this.parent().hide();
    }
  };

  var bindUIActions = function bindUIActions() {
    $load.on('click', function runLoad() {
      var $this = $(this);

      showMore($this);
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  CollectionsDisplay.init = init;
})(window.CollectionsDisplay = window.CollectionsDisplay || {}, jQuery);
'use strict';

(function (Copyright, $) {
  'use strict';

  var $copyright = void 0;

  var cacheDom = function cacheDom() {
    $copyright = $('.copyright-to-year');
  };

  var updateYear = function updateYear() {
    var date = new Date();
    var year = date.getFullYear();
    $copyright.text(year);
  };

  var init = function init() {
    cacheDom();
    updateYear();
  };

  Copyright.init = init;
})(window.Copyright = window.Copyright || {}, jQuery);
'use strict';

(function (CountdownTimer, $) {
  'use strict';

  var cacheDom = function cacheDom(options, userOptions) {
    if (userOptions.countdownElement) {
      options.$countdown = $(userOptions.countdownElement);
    } else {
      options.$countdown = $('.countdown-timer');
    }

    options.$days = options.$countdown.find('[data-countdown-days]');
    options.$hours = options.$countdown.find('[data-countdown-hours]');
    options.$minutes = options.$countdown.find('[data-countdown-minutes]');
    options.$seconds = options.$countdown.find('[data-countdown-seconds]');
  };

  var render = function render(time, options) {
    options.$days.text(time.days);
    options.$hours.text(time.hours);
    options.$minutes.text(time.minutes);
    options.$seconds.text(time.seconds);
  };

  var getTimeRemaining = function getTimeRemaining(endtime) {
    var timezoneOffset = new Date().getTimezoneOffset();

    var t = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor(t / 1000 % 60).toString();
    var minutes = Math.floor(t / 1000 / 60 % 60).toString();
    var hours = Math.floor(t / (1000 * 60 * 60) % 24).toString();
    var days = Math.floor(t / (1000 * 60 * 60 * 24)).toString();

    t += timezoneOffset * 60 * 1000;

    if (parseInt(seconds, 10) > 0 || parseInt(minutes, 10) > 0 || parseInt(hours, 10) > 0 || parseInt(days, 10) > 0) {
      if (seconds.length === 1) {
        seconds = '0' + seconds;
      }

      if (minutes.length === 1) {
        minutes = '0' + minutes;
      }

      if (hours.length === 1) {
        hours = '0' + hours;
      }

      if (days.length === 1) {
        days = '0' + days;
      }
    } else {
      seconds = '00';
      minutes = '00';
      hours = '00';
      days = '00';
    }

    return {
      total: t,
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  };

  var setOptions = function setOptions(options, userOptions) {
    options.deadline = userOptions.deadline;

    if (userOptions.dst) {
      options.dst = true;
    } else {
      options.dst = false;
    }
  };

  var init = function init(userOptions) {
    if (!userOptions) {
      userOptions = {};
    }

    if (userOptions.deadline) {
      var options = {};
      var time = void 0;

      cacheDom(options, userOptions);
      setOptions(options, userOptions);
      time = getTimeRemaining(options.deadline);
      render(time, options);
      options.$countdown.show();

      setInterval(function () {
        var time = getTimeRemaining(options.deadline);
        render(time, options);
      }, 1000);
    }
  };

  CountdownTimer.init = init;
})(window.CountdownTimer = window.CountdownTimer || {}, jQuery);
'use strict';

(function (CurrencyWidget, $) {
  'use strict';

  var arrowRotateClass = 'currency-arrow-rotate';
  var mobileActiveClass = 'mobile-options-item-active';
  var desktopActiveTogglerClass = 'desktop-currency-display-text-wrapper-active';
  var desktopActiveItemClass = 'desktop-options-item-active';
  var globalActiveItemClass = 'currency-item-active';

  var $mobileNav = void 0;
  var $mobileToggle = void 0;
  var $mobileCurrencyList = void 0;
  var $mobileItem = void 0;
  var $desktopCurrencyWrapper = void 0;
  var $desktopCurrencyToggle = void 0;
  var $desktopCurrencyItem = void 0;
  var $desktopCurrencyDisplayText = void 0;
  var $currencyArrow = void 0;
  var $currencyItem = void 0;
  var $window = void 0;

  var cacheDom = function cacheDom() {
    $mobileNav = $('.js-mobile-nav-dropdown');
    $mobileToggle = $mobileNav.find('.js-mobile-currency-toggle');
    $mobileCurrencyList = $mobileNav.find('.js-mobile-currency-list');
    $mobileItem = $mobileNav.find('.js-mobile-currency-item');

    $desktopCurrencyWrapper = $('.js-desktop-currency-wrapper');
    $desktopCurrencyToggle = $desktopCurrencyWrapper.find('.js-desktop-currency-toggle');
    $desktopCurrencyItem = $desktopCurrencyWrapper.find('.js-desktop-currency-item');
    $desktopCurrencyDisplayText = $desktopCurrencyWrapper.find('.js-desktop-currency-display-text');

    $currencyArrow = $('.js-currency-arrow');
    $currencyItem = $('[data-currency-item]');
    $window = $(window);
  };

  var arrowToggle = function arrowToggle(self) {
    var $arrow = $(self).find($currencyArrow);

    if ($arrow.hasClass(arrowRotateClass)) {
      $arrow.removeClass(arrowRotateClass);
    } else {
      $arrow.addClass(arrowRotateClass);
    }
  };

  var desktopActiveToggle = function desktopActiveToggle() {
    if ($desktopCurrencyToggle.hasClass(desktopActiveTogglerClass)) {
      $desktopCurrencyToggle.removeClass(desktopActiveTogglerClass);
    } else {
      $desktopCurrencyToggle.addClass(desktopActiveTogglerClass);
    }
  };

  var desktopToggle = function desktopToggle(self) {
    arrowToggle(self);
    desktopActiveToggle();
  };

  var getCurrency = function getCurrency() {
    return window.Geolizr.cookie('geolizr-currency') || 'USD';
  };

  var setActiveClass = function setActiveClass($this, localActiveClass, globalActiveItemClass, currency) {
    if ($this.data('currency').toLowerCase() === currency.toLowerCase()) {
      $this.addClass(localActiveClass).addClass(globalActiveItemClass);
    }
  };

  var initialCurrencyView = function initialCurrencyView() {
    var currency = getCurrency();

    $desktopCurrencyDisplayText.text(currency);

    $mobileItem.removeClass(mobileActiveClass).removeClass(globalActiveItemClass);
    $mobileItem.each(function setActiveCurrencyMobile() {
      setActiveClass($(this), mobileActiveClass, globalActiveItemClass, currency);
    });

    $desktopCurrencyItem.removeClass(desktopActiveItemClass).removeClass(globalActiveItemClass);
    $desktopCurrencyItem.each(function setActiveCurrencyDesktop() {
      setActiveClass($(this), desktopActiveItemClass, globalActiveItemClass, currency);
    });
  };

  var removeCurrencyWidget = function removeCurrencyWidget() {
    var listID = 'geolizr-currency-list';
    var listSwitcher = 'geolizr-currency-switcher';

    $('#' + listID).remove();
    $('#' + listSwitcher).remove();
  };

  var setCurrency = function setCurrency(currency) {
    if (window.Geolizr && window.GeolizrAPI && window.GeolizrAPI.api) {
      window.GeolizrAPI.api.switchCurrency(currency);
    }
  };

  var clickBind = function clickBind() {
    /* MOBILE SPECIFIC */
    $mobileToggle.on('click', function toggleCurrencyListMobile() {
      if ($('.js-mobile-language-list').is(':visible')) {
        $('.js-mobile-language-list').slideToggle();
      }
      $mobileCurrencyList.slideToggle();
      arrowToggle(this);
    });

    $mobileItem.on('click', function setActiveMobile() {
      if (!$(this).hasClass(mobileActiveClass)) {
        $mobileItem.removeClass(mobileActiveClass).removeClass(globalActiveItemClass);
        $(this).addClass(mobileActiveClass).addClass(globalActiveItemClass);
      }
    });

    /* DESKTOP SPECIFIC */
    $desktopCurrencyToggle.on('click', function toggleCurrency() {
      desktopToggle(this);
    });

    $desktopCurrencyItem.on('click', function toggleCurrencyDesktop() {
      if (!$(this).hasClass(desktopActiveItemClass)) {
        $desktopCurrencyItem.removeClass(desktopActiveItemClass).removeClass(globalActiveItemClass);
        $(this).addClass(desktopActiveItemClass).addClass(globalActiveItemClass);
      }
      window.OptionsDropdown.toggle();
    });

    /* GLOBAL */
    $currencyItem.on('click', function updatePrices() {
      var currencyCode = $(this).data('currency');

      $desktopCurrencyDisplayText.text(currencyCode);

      if ($(this).hasClass('desktop-currency-item')) {
        $mobileItem.removeClass(mobileActiveClass).removeClass(globalActiveItemClass);
        $mobileItem.each(function setActiveMobileClass() {
          setActiveClass($(this), mobileActiveClass, globalActiveItemClass, currencyCode);
        });

        desktopToggle($(this).parents('.js-desktop-currency-wrapper').find('.js-desktop-currency-toggle')[0]);
      } else {
        $desktopCurrencyItem.removeClass(desktopActiveItemClass).removeClass(globalActiveItemClass);
        $desktopCurrencyItem.each(function setActiveDesktopClass() {
          setActiveClass($(this), desktopActiveItemClass, globalActiveItemClass, currencyCode);
        });

        $mobileCurrencyList.slideToggle();
        arrowToggle($(this).parents('.mobile-nav-items').find('.js-mobile-currency-toggle')[0]);
      }

      setCurrency($(this).data('currency'));
    });
  };

  var windowBind = function windowBind() {
    $window.on('load', function () {
      $currencyItem.each(function setCurrencyOnLoad() {
        var currency = $(this).data('currency');
        var keys = Object.keys(window.Geolizr.currencies);
        for (var i = 0; i < keys.length; i++) {
          if (window.Geolizr.currencies[keys[i]].toLowerCase() === currency.toLowerCase()) {
            $(this).attr('data-country', keys[i]);
            break;
          }
        }
        if (currency === 'USD') {
          $(this).attr('data-country', 'US');
        }
      });

      removeCurrencyWidget();
      initialCurrencyView();
    });
  };

  var bindUIActions = function bindUIActions(options) {
    clickBind();
    windowBind();

    if (options.displayCurrency) {
      if (window.Geolizr && window.GeolizrAPI) {
        window.GeolizrAPI.addEventListener('currency.change', function () {
          $('[data-geolizr-price]').css('opacity', '1');
        });
      }
    }
  };

  var init = function init(options) {
    cacheDom();
    bindUIActions(options);
  };

  CurrencyWidget.init = init;
})(window.CurrencyWidget = window.CurrencyWidget || {}, jQuery);
"use strict";

;(function (Debounce, $) {

  Debounce.wait = function (func, wait, immediate) {
    var timeout = void 0;
    return function () {
      var context = this;
      var args = arguments;

      var later = function later() {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  };
})(window.Debounce = window.Debounce || {}, jQuery);
'use strict';

(function (Disclaimer, $) {
  'use strict';

  var $disclaimer = void 0;
  var $check = void 0;
  var $agree = void 0;

  var cacheDom = function cacheDom() {
    $disclaimer = $('.js-disclaimer-wrapper');
    $check = $disclaimer.find('.js-disclaimer-checkbox');
    $agree = $disclaimer.find('.js-disclaimer-agree');
  };

  var bindUIActions = function bindUIActions() {
    $check.on('change', function checkChange() {
      var $this = $(this);

      if ($this.is(':checked')) {
        $agree.removeClass('disclaimer-disable');
      } else {
        $agree.addClass('disclaimer-disable');
      }
    });

    $agree.on('click', function () {
      $(this).parents('.modal').find('.modal-close').click();
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  Disclaimer.init = init;
})(window.Disclaimer = window.Disclaimer || {}, jQuery);
'use strict';

(function (ForceLang) {
  'use strict';

  var matrix = {};
  var urlQuery = window.location.search;
  var queryStrip = 5;

  var lang = void 0;

  var buildMatrixObject = function buildMatrixObject(languageMatrix) {
    var matrixArray = languageMatrix.split(',');

    for (var i = 0; i < matrixArray.length; i++) {
      var languageArray = matrixArray[i].split('=');
      matrix[languageArray[0]] = languageArray[1];
    }
  };

  var getQuery = function getQuery() {
    var queries = urlQuery.substr(1, urlQuery.length).split('&');
    var query = void 0;

    for (var i = 0; i < queries.length; i++) {
      if (queries[i].indexOf('lang=') >= 0) {
        query = queries[i];
        break;
      }
    }

    lang = query.substr(queryStrip, query.length);
  };

  var setCookie = function setCookie() {
    var thirtyMinutes = 1 / 48;
    window.Cookies.set('BVAForceLang', 'true', {
      expires: thirtyMinutes
    });
  };

  var checkCookie = function checkCookie() {
    return window.Cookies.get('BVAForceLang');
  };

  var changeLanguage = function changeLanguage() {
    var langifyId = matrix[lang];

    $(document).ready(function () {
      if (langifyId && window.langify && !checkCookie()) {
        if (langifyId !== langify.helper.getSelectedLanguage()) {
          window.langify.helper.saveLanguage(langifyId);
          setCookie();
        }
      }
    });
  };

  var init = function init(languageMatrix) {
    buildMatrixObject(languageMatrix);
    getQuery();
    changeLanguage();
  };

  ForceLang.init = init;
})(window.ForceLang = window.ForceLang || {});
'use strict';

(function (Global, $) {
  'use strict';

  // FADE IN SCROLL
  // Test two

  var fadeScroll = function fadeScroll() {
    var scrollDistance;
    $(window).scroll(onScrollHandler);

    function onScrollHandler() {
      var $fadeItem = $('.fade-item');
      scrollDistance = $(document).scrollTop();
      $fadeItem.each(function () {
        if (isScrolledIntoView(this) === true) {
          $(this).addClass('enter-viewport');
        }
      });
    }

    function isScrolledIntoView(elem) {
      // distance of top of page, to bottom of screen.
      var docViewBottom = scrollDistance + $(window).height();

      // position of the element
      var elemTop = $(elem).offset().top;

      // elements are offset by 90px, but we want to scroll them into view
      // once they are 200px into view
      return docViewBottom >= elemTop - 90 + 250;
    }

    // limit how often a function gets triggered
    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
            args = arguments;
        var later = function later() {
          timeout = null;
          if (!immediate) {
            func.apply(context, args);
          }
        };

        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
          func.apply(context, args);
        }
      };
    }
  }; // End _fadeScroll()

  // Event Bindings
  var bindUIActions = function bindUIActions() {
    $('.mobile-nav-items a.no-padding').click(function () {
      var linkURL = $(this).attr('href');
      window.location.href = linkURL;
      return false;
    });

    // Toggle Sweet Tooth Modal
    $('[href="#vip-rewards"]').on('click', function (e) {
      e.preventDefault();
      SweetTooth.publish('st-intent', 'st:core:home');
    });

    $('.more-dropdown-box').delegate('[href="#vip-rewards"]', 'click', function (e) {
      e.preventDefault();
      SweetTooth.publish('st-intent', 'st:core:home');
    });

    // Email Form Validation From Popup
    $('#mc_embed_signup').find('form').ajaxChimp();

    // Interstitial Cookie + Popup
    setTimeout(function () {
      var modalDisplayedCookie = Boolean(window.Cookies.get('modal_displayed'));
      var interstitialValue = '{{settings.interstitial}}';

      if (!modalDisplayedCookie) {

        window.Cookies.set('modal_displayed', true, { expires: 1 });

        if (interstitialValue === 'promo') {
          fleshlight.methods.modals._open('', 'free-shipping');
        } else if (interstitialValue === 'email') {
          fleshlight.methods.modals._open('', 'percent-off');
        } else {
          return;
        }
      }
    }, 3000);
  };

  // Public
  var init = function init() {
    fadeScroll();
    bindUIActions();
  };

  Global.init = init;
})(window.Global = window.Global || {}, jQuery);
'use strict';

(function (HoverProductImage, $) {
  'use strict';

  var $gridItem = void 0;

  var cacheDom = function cacheDom() {
    $gridItem = $('.js-product-grid-item');
  };

  var bindUIActions = function bindUIActions() {
    $gridItem.on('mouseenter', function () {
      var $img = $(this).find('.img-main');
      var hasHoverImg = $img.attr('src-hover') || false;
      if (hasHoverImg) {
        var hoverImgSrc = $img.attr('src-hover');
        $img.attr('src', hoverImgSrc);
      }
    });

    $gridItem.on('mouseleave', function () {
      var $img = $(this).find('.img-main');
      var mainImgSrc = $img.attr('src-main');
      $img.attr('src', mainImgSrc);
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  HoverProductImage.init = init;
})(window.HoverProductImage = window.HoverProductImage || {}, jQuery);
'use strict';

(function (HoverText, $) {
  'use strict';

  var $body = void 0;

  var cacheDom = function cacheDom() {
    $body = $('body');
  };

  var desktopToggle = function desktopToggle($this, visibility) {
    var windowWidth = $(window).width();
    var $text = $this.find('.hover-text-info');
    if (windowWidth > 1024) {
      if (visibility === 'show') {
        $text.slideDown();
      } else {
        $text.slideUp();
      }
    }
  };

  var bindUIActions = function bindUIActions() {
    $body.delegate('.line-item, .cart-item', 'mouseover', function () {
      desktopToggle($(this), 'show');
    });

    $body.delegate('.line-item, .cart-item', 'mouseleave', function () {
      desktopToggle($(this), 'hide');
    });

    $body.delegate('.line-item .cart-display-text, .cart-item .cart-display-text', 'touchstart, click', function () {
      var windowWidth = $(window).width();
      if (windowWidth < 1025) {
        $(this).closest('.line-item, .cart-item').find('.hover-text-info').slideToggle();
      }
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  HoverText.init = init;
})(window.HoverText = window.HoverText || {}, jQuery);
'use strict';

(function (HpSlider, $) {
  'use strict';

  var $slider = void 0;
  var $slider2 = void 0;

  var cacheDom = function cacheDom() {
    $slider = $('.hp-slider');
    $slider2 = $('.top-pornstars-slider');
  };

  var bindUIActions = function bindUIActions() {
    $slider.on('initialized.owl.carousel', function () {
      $slider.css('opacity', 1);
    });

    $slider2.on('initialized.owl.carousel', function () {
      $slider2.css('opacity', 1);
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  HpSlider.init = init;
})(window.HpSlider = window.HpSlider || {}, $);
'use strict';

(function (InlineCart, $) {
  'use strict';

  /*
   *  Dependency: <div class="overlay" data-overlay></div> in theme.liquid,
   *              components/_overlay.scss
   *
   *  Note: _overlay.scss hold the styles for the overlay container
   *  Note: .overlay has a z-index of 1000, so any modal that needs to appear on top
   *        of the overlay need to have an z-index of 1001+
   *
   *
   */

  var $lineItemEntryPoint = $('[data-cart-contents]');
  var $pageLineItemEntryPoint = $('.js-cart-page-insertion');
  var $navCount = $('[data-edit="cart-count"]');
  var freeShippingAmt = window.shop.freeShippingAmt;
  var $cartBottom = $('.cart-bottom');
  var $shippingPromo = $('.shipping-promo');

  var country = void 0;

  var setCurrency = function setCurrency() {
    var currency = window.GeolizrAPI.api.getCurrency();
    window.GeolizrAPI.api.switchCurrency(currency);
  };

  var pollForGeolizerApi = setInterval(function () {
    if (window.GeolizrAPI && window.GeolizrAPI.api) {
      setCurrency();
      clearInterval(pollForGeolizerApi);
    }
  }, 1000);

  var setCountry = function setCountry(inputCountry) {
    country = inputCountry;
  };

  var updatePrices = function updatePrices($price) {
    if ($price.length) {
      $price.each(function () {
        if (!$price.attr('data-price-changed')) {
          $price.attr('data-price-changed', 'true');
          window.AddTax.setPrice($price, 'data-geolizr-price');
        }
      });
    }
  };

  var resetCartButton = function resetCartButton() {
    if (!$shippingPromo.length) {
      $cartBottom.css('bottom', '105px');
    }
  };

  var updateShippingPromo = function updateShippingPromo() {
    var subTotalAmt = (window.CartJS.cart.total_price / 100).toFixed(2);
    window.fleshlight.methods.cart._update_shipping_promo(subTotalAmt, freeShippingAmt);
  };

  var setCartInner = function setCartInner() {
    if (window.Geolizr && window.GeolizrAPI && window.GeolizrAPI.api) {
      if (country && country.toLowerCase() === 'au') {
        var $price = $('.cart-sidecar [data-geolizr-price]');
        updatePrices($price);
      }
      setCurrency();
    }
    updateShippingPromo();
  };

  var getCartContents = function getCartContents() {
    $.get('/cart?view=contents', function (response) {
      $lineItemEntryPoint.html(response);
      setCartInner();
    });

    if ($pageLineItemEntryPoint.length) {
      $.get('/cart?view=page-contents', function (response) {
        $pageLineItemEntryPoint.html(response);
        setCartInner();
      });
    }
  };

  var addToCartError = function addToCartError(jqXHR) {
    window.alert('Sorry, we\'re unable to do that.\n' + JSON.parse(jqXHR.responseText).description);
  };

  var builderAddToCart = function builderAddToCart(self) {
    var variantId = $(self).attr('data-variant-id');
    var variantQty = $(self).attr('data-variant-qty');

    var accessoryIds = $(self).attr('data-accessories-ids');

    if (accessoryIds.indexOf(',') < 0) {
      accessoryIds = accessoryIds.split();
    } else {
      accessoryIds = accessoryIds.split(',');
    }

    var selectedSteps = [];

    $.each($(':checked'), function addStep(i, val) {
      var stepVal = $(this).val();
      selectedSteps.push(stepVal);
    });

    window.CartJS.addItem(variantId, variantQty, {
      Case: selectedSteps[0],
      Orifice: selectedSteps[1],
      Texture: selectedSteps[2]
    }, {
      error: addToCartError
    });

    if (accessoryIds[0].length > 0) {
      accessoryIds.forEach(function (id) {
        window.CartJS.addItem(id, 1, {}, {
          error: addToCartError
        });
      });
    }
  };

  var addLineItem = function addLineItem(self) {
    var variantId = $(self).attr('data-variant-id');
    var variantQty = $(self).attr('data-variant-qty');
    var hoverText = $(self).attr('data-hover-text');
    var moreInfo = {
      Description: hoverText
    };

    if ($(self).attr('data-disclaimer-accept')) {
      moreInfo.Disclaimer = 'I have read the instructions and precautions for this product, and agree to the terms.';
    }

    if ($('body').hasClass('product-builder')) {
      builderAddToCart(self);
    } else {
      window.CartJS.addItem(variantId, variantQty, moreInfo, {
        error: addToCartError
      });
    }
  };

  var removeLineItem = function removeLineItem(self) {
    var lineItem = $(self).attr('data-line-index');
    window.CartJS.removeItem(lineItem);
  };

  var triggerInlineCart = function triggerInlineCart() {
    $('body').toggleClass('cart-open');
    $('.cart-sidecar-overlay').addClass('animate-in');
  };

  var bindUIActions = function bindUIActions() {
    $(document).on('click', '[data-add-to-cart]', function disclamierCheck(event) {
      event.preventDefault();
      var $disclaimerSubmit = $('.js-disclaimer-agree');

      if ($(this).attr('data-disclaimer')) {
        $disclaimerSubmit.attr('data-variant-qty', $(this).attr('data-variant-qty'));
        $disclaimerSubmit.attr('data-variant-id', $(this).attr('data-variant-id'));
        $disclaimerSubmit.attr('data-hover-text', $(this).attr('data-hover-text'));
      } else {
        addLineItem(this);

        if ($('body').hasClass('page-cart')) {
          triggerInlineCart();
        }
      }
    });

    $(document).on('change', '[name="item-quantity"]', function quantityChange() {
      var QtyVarID = $(this).attr('data-variant-id');
      var QtyAmt = $(this).val();
      window.CartJS.updateItemById(QtyVarID, QtyAmt);

      if ($('body').hasClass('page-cart')) {
        var lineItemTotal = $(this).attr('data-variant-price');
        var convertedlineItem = parseFloat(lineItemTotal * QtyAmt);
        $(this).closest('.cart-item').find('.price-actual').find('[data-geolizr-price]').attr('data-geolizr-price', convertedlineItem);
        if (window.GeolizrAPI && window.GeolizrAPI.api) {
          window.GeolizrAPI.api.switchCurrency(window.GeolizrAPI.api.getCurrency());
        }
      }
    });

    $(document).on('change', '[name="quantity"]', function quantityUpdate() {
      var QtyAmt = $(this).val();
      $('.button-container .button').attr('data-variant-qty', QtyAmt);
    });

    $(document).on('click', '[data-action="cart-sidecard-remove-item"]', function removeItemFromCart() {
      removeLineItem(this);
    });

    $(document).on('click', '[data-action="cart-close"]', function closeCart() {
      window.fleshlight.methods.cart._close();
    });

    $(document).on('cart.requestComplete', function (event, cart) {
      var updateCartCount = function updateCartCount() {
        $navCount.text(cart.item_count);

        if ($('body').hasClass('page-cart')) {
          $('.cart-review .subtotal [data-geolizr-price]').attr('data-geolizr-price', cart.total_price);
        }
      };

      getCartContents();
      updateCartCount();
      updateShippingPromo();
    });

    $pageLineItemEntryPoint.on('click', '.cart-item-remove', function removeCartItem(event) {
      event.preventDefault();
      var lineNumber = parseInt($(this).attr('data-line-number'));
      window.CartJS.removeItem(lineNumber);
    });
  };

  var init = function init(country) {
    setCountry(country);
    bindUIActions();
    getCartContents();
    resetCartButton();
  };

  InlineCart.init = init;
  InlineCart.triggerInlineCart = triggerInlineCart;
})(window.InlineCart = window.InlineCart || {}, jQuery);
'use strict';

/**
  *
  * DEPENDENCIES: Scroll.js
  *
  */

(function (InstagramModal, $) {
  'use strict';

  var allImages = [];

  var $instagramFeed = void 0;
  var $body = void 0;

  var cacheDom = function cacheDom() {
    $instagramFeed = $('.instagram-feed');
    $body = $('body');
  };

  var buildModal = function buildModal(sourceImage, index) {
    var html = '';
    html += '<div id="instagram-modal">';
    html += '<div class="instagram-modal-hide"></div>';
    html += '<div class="instagram-modal-image-container">';
    html += '<img class="instagram-modal-image"';
    html += 'data-current-index="';
    html += index;
    html += '" src="';
    html += sourceImage;
    html += '" />'; // Ends/Closes img tag
    html += '<div class="instagram-modal-x"><p class="fa fa-times"></p></div>';
    html += '<div class="instagram-modal-prev" data-index="';
    html += index; // Index left in but not necessary
    html += '"><p class="fa fa-chevron-circle-left"></p></div>';
    html += '<div class="instagram-modal-next" data-index="';
    html += index; // Index left in but not necessary
    html += '"><p class="fa fa-chevron-circle-right"></p></div>';
    html += '</div>';
    html += '</div>';
    return html;
  };

  var setImageIndexes = function setImageIndexes(currentIndex, changeType) {
    var newPrevIndex = void 0;
    var newNextIndex = void 0;
    var newImgIndex = void 0;

    if (currentIndex === 0 && changeType === 'prev') {
      newPrevIndex = allImages.length - 2;
      newNextIndex = currentIndex;
      newImgIndex = allImages.length - 1;
    } else if (currentIndex === allImages.length - 1 && changeType === 'next') {
      newPrevIndex = currentIndex;
      newNextIndex = 1;
      newImgIndex = 0;
    } else if (currentIndex === 1 && changeType === 'prev') {
      newPrevIndex = allImages.length - 1;
      newNextIndex = currentIndex;
      newImgIndex = 0;
    } else if (currentIndex === allImages.length - 2 && changeType === 'next') {
      newPrevIndex = currentIndex;
      newNextIndex = 0;
      newImgIndex = currentIndex + 1;
    } else if (changeType === 'prev') {
      newPrevIndex = currentIndex - 2;
      newNextIndex = currentIndex;
      newImgIndex = currentIndex - 1;
    } else if (changeType === 'next') {
      newPrevIndex = currentIndex;
      newNextIndex = currentIndex + 2;
      newImgIndex = currentIndex + 1;
    }

    return [newPrevIndex, newNextIndex, newImgIndex];
  };

  var changeImage = function changeImage($imgTag, indexes) {
    $imgTag.parent().hide().find('.instagram-modal-prev').attr('data-index', indexes[0]).parent().find('.instagram-modal-next').attr('data-index', indexes[1]).parent().find('img').attr('src', allImages[indexes[2]]).attr('data-current-index', indexes[2]).parent().fadeIn(300);
  };

  var itemIndexInArray = function itemIndexInArray(arr, item) {
    return arr.indexOf(item);
  };

  var show = function show() {
    $('#instagram-modal').fadeIn(300).css('display', 'flex');
    window.Scroll.lock();
  };

  var switchModal = function switchModal($node, direction) {
    var $imgTag = $node.parent().find('img');
    var currentIndex = parseInt($node.parent().find('img').attr('data-current-index'), 10);
    var indexes = setImageIndexes(currentIndex, direction);

    changeImage($imgTag, indexes);
  };

  var bindUIActions = function bindUIActions() {
    $(document).on('keydown', function (event) {
      if ($('#instagram-modal').is(':visible')) {
        if (event.keyCode.toString() === '37') {
          var node = $('.instagram-modal-prev');
          switchModal(node, 'prev');
        }

        if (event.keyCode.toString() === '39') {
          var _node = $('.instagram-modal-next');
          switchModal(_node, 'next');
        }
      }
    });

    $instagramFeed.delegate('img', 'click', function createModal() {
      var currentImage = $(this).attr('src');

      if (allImages.length === 0) {
        $($(this).parent().children('img')).each(function pushToArray() {
          allImages.push($(this).attr('src'));
        });
      }

      var index = itemIndexInArray(allImages, currentImage);
      var html = buildModal(currentImage, index);

      $body.prepend(html);

      show();
    });

    $body.delegate('.instagram-modal-hide', 'click', function hideModal() {
      $(this).parent().fadeOut(300).remove();
      window.Scroll.unlock();
    });

    $body.delegate('.instagram-modal-x', 'click', function hideModalFromX() {
      $(this).parent().parent().fadeOut(300).remove();
      window.Scroll.unlock();
    });

    $body.delegate('.instagram-modal-prev', 'click', function previousItem() {
      switchModal($(this), 'prev');
    });

    $body.delegate('.instagram-modal-next', 'click', function nextItem() {
      switchModal($(this), 'next');
    });

    $instagramFeed.delegate('.instagram-feed-promo', 'click', function () {
      var currentImage = $($instagramFeed.find('#instafeed').children()[0]).attr('src');

      if (allImages.length === 0) {
        $($instagramFeed.find('#instafeed').children('img')).each(function pushToArray() {
          allImages.push($(this).attr('src'));
        });
      }

      var index = itemIndexInArray(allImages, currentImage);
      var html = buildModal(currentImage, index);

      $body.prepend(html);

      show();
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  InstagramModal.init = init;
})(window.InstagramModal = window.InstagramModal || {}, jQuery);
'use strict';

(function (LanguageWidget, $) {
  'use strict';

  var mobileActiveClass = 'mobile-options-item-active';
  var desktopActiveItemClass = 'desktop-options-item-active';

  var $mobileToggle = void 0;
  var $mobileDropdown = void 0;
  var $desktopLanguageItem = void 0;
  var $mobileLanguageItem = void 0;

  var cacheDom = function cacheDom() {
    $mobileToggle = $('.js-mobile-language-toggle');
    $mobileDropdown = $('.js-mobile-language-list');
    $desktopLanguageItem = $('.js-desktop-langauage-item');
    $mobileLanguageItem = $('.js-mobile-language-item');
  };

  var changeActiveState = function changeActiveState($this, activeClass, $languageItem) {
    if (!$this.hasClass(activeClass)) {
      $languageItem.removeClass(activeClass);
      $this.addClass(activeClass);
    }
  };

  var clickBinds = function clickBinds() {
    $mobileToggle.on('click', function () {
      if ($('.js-mobile-currency-list').is(':visible')) {
        $('.js-mobile-currency-list').slideToggle();
      }
      $mobileDropdown.slideToggle();
    });

    $mobileLanguageItem.on('click', function changeMobileActiveState() {
      changeActiveState($(this), mobileActiveClass, $mobileLanguageItem);
    });

    $desktopLanguageItem.on('click', function changeDesktopActiveState() {
      changeActiveState($(this), desktopActiveItemClass, $desktopLanguageItem);
    });
  };

  var bindUIActions = function bindUIActions() {
    clickBinds();
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  LanguageWidget.init = init;
})(window.LanguageWidget = window.LanguageWidget || {}, jQuery);
'use strict';

(function (LaunchParallax, $) {
  'use strict';

  var scrollSpeedDivider = 4;
  var mobileBreak = 992;

  var $window = void 0;
  var $hero = void 0;
  var $image = void 0;

  var showImage = function showImage() {
    $image.css('opacity', 1);
  };

  var parallax = function parallax($this) {
    var scrollHeight = $this.scrollTop();
    $image.css('transform', 'translateY(-' + scrollHeight / scrollSpeedDivider + 'px)');
  };

  var initialize = function initialize() {
    if (checkScroll($window)) {
      parallax($window);
    } else {
      reset();
    }
    showImage();
  };

  var checkScroll = function checkScroll($this) {
    return $this.scrollTop() < $hero.height() && $this.width() > mobileBreak;
  };

  var reset = function reset() {
    $image.css('transform', 'translateY(0)');
  };

  var cacheDom = function cacheDom() {
    $window = $(window);
    $hero = $('.js-launch-hero');
    $image = $hero.find('.js-launch-hero-image');
  };

  var bindUIActions = function bindUIActions() {
    $window.on('scroll', function () {
      if (checkScroll($(this))) {
        parallax($(this));
      }
    });

    $window.on('resize', function () {
      initialize();
    });
  };

  var init = function init() {
    cacheDom();
    initialize();
    bindUIActions();
  };

  LaunchParallax.init = init;
})(window.LaunchParallax = window.LaunchParallax || {}, jQuery);
'use strict';

(function (MailChimp, $) {
  'use strict';

  var $form = void 0;
  var $notification = void 0;

  var cacheDom = function cacheDom() {
    $form = $('.js-mailchimp-footer');
    $notification = $('.js-mailchimp-notification');
  };

  var showNotification = function showNotification(message) {
    $form.hide();
    $notification.text(message).fadeIn().css('display', 'inline-block');
  };

  var register = function register() {
    var successMessage = 'Thank you! Verification email sent!';
    var errorMessage = 'An error was encountered. Please try again later.';
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache: false,
      dataType: 'jsonp',
      contentType: 'application/json; charset=utf-8',
      error: function error(err) {
        if (err.status === 200) {
          showNotification(successMessage);
        } else {
          showNotification(errorMessage);
        }
      },
      success: function success() {
        showNotification(successMessage);
      }
    });
  };

  var submitBind = function submitBind() {
    $form.on('submit', function (event) {
      event.preventDefault();
      register();
    });
  };

  var bindUIActions = function bindUIActions() {
    submitBind();
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  MailChimp.init = init;
})(window.MailChimp = window.MailChimp || {}, jQuery);
'use strict';

(function (MegaCollection, $) {
  'use strict';

  var $navSlider = void 0;

  var cacheDom = function cacheDom() {
    $navSlider = $('[super-collection-nav-slider]');
  };

  var initNavSlider = function initNavSlider() {
    console.log('Slider initializing...');
    $navSlider.slick({
      slidesToShow: 5,
      autoplay: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          autoplay: true
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          autoplay: true
        }
      }]
    });
  };

  var bindUIActions = function bindUIActions() {};

  var init = function init() {
    cacheDom();
    initNavSlider();
    // bindUIActions();
  };

  MegaCollection.init = init;
})(window.MegaCollection = window.MegaCollection || {}, jQuery);
'use strict';

(function (Modal, $) {
  /**
    *
    *  Dependencies: Overlay.js
    *                components/_overlay.scss
    *                <div class="overlay" data-overlay></div> in theme.liquid
    *
    */

  var show = function show(modalName) {
    window.Overlay.show();
    window.Scroll.lock();
    $('[data-modal="' + modalName + '"]').fadeIn(300);
    $('body').attr('data-active-modal', modalName);
  };

  var hide = function hide() {
    window.Overlay.hide();
    window.Scroll.unlock();
    $('[data-modal]').fadeOut(300);
    $('body').removeAttr('data-active-modal');
  };

  var arrows = function arrows() {
    var modalLength = $('.modal.photo').length - 1;

    var checkKey = function checkKey(e) {
      var $currentModelImg = $('.modal.photo.open');

      e = e || window.event;
      if (e.keyCode == '37' || e.keyCode == '39') {
        $($currentModelImg).removeClass('open');
      }

      if (e.keyCode == '37') {
        if ($($currentModelImg).attr('data-index') == 0) {
          $('.modal.photo[data-index="' + modalLength + '"]').addClass('open');
        } else {
          $($currentModelImg).prev().addClass('open');
        }
      } else if (e.keyCode == '39') {
        if ($($currentModelImg).attr('data-index') == modalLength) {
          $('.modal.photo[data-index="0"]').addClass('open');
        } else {
          $($currentModelImg).next().addClass('open');
        }
      }
    };

    window.document.onkeydown = checkKey;
  };

  var bindUIActions = function bindUIActions() {
    $('[data-modal-show]').on('click', function (event) {
      event.preventDefault();
      show($(this).attr('data-modal-show'));
    });

    $('[data-modal-hide]').on('click', function (event) {
      event.preventDefault();
      hide();
    });

    arrows();
  };

  var init = function init() {
    bindUIActions();
  };

  Modal.init = init;
  Modal.arrows = arrows;
  Modal.hide = hide;
  Modal.show = show;
})(window.Modal = window.Modal || {}, jQuery);
'use strict';

(function (OptionsDropdown, $) {
  'use strict';

  var $dom = {};

  var cacheDom = function cacheDom() {
    $dom.optionsWrapper = $('.js-desktop-options-wrapper');
    $dom.dropdownToggle = $dom.optionsWrapper.find('.js-desktop-options-toggle');
    $dom.dropdown = $dom.optionsWrapper.find('.js-desktop-options-dropdown');
    $dom.moreDropdown = $('.js-more-dropdown');
  };

  var toggle = function toggle() {
    $dom.dropdown.slideToggle();
    $dom.optionsWrapper.toggleClass('is-open');
  };

  var clickBinds = function clickBinds() {
    $dom.dropdownToggle.on('click', function () {
      toggle();
    });

    $dom.moreDropdown.on('click', function () {
      if ($dom.dropdown.is(':visible')) {
        $dom.dropdown.slideUp();
      }
    });
  };

  var bindUIActions = function bindUIActions() {
    clickBinds();
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  OptionsDropdown.init = init;
  OptionsDropdown.toggle = toggle;
})(window.OptionsDropdown = window.OptionsDropdown || {}, jQuery);
'use strict';

(function (Orgy, $) {
  'use strict';

  var breakpoint = 991;

  var girlsSum = 0;
  var $mainNavDesktop = void 0;
  var $addedSleeves = void 0;
  var $topBanner = void 0;
  var $hero = void 0;
  var originalOffset = void 0;
  var isMobile = 0;
  var collectionHandle = void 0;

  var cacheDom = function cacheDom() {
    $mainNavDesktop = $('.main-navigation');
    $addedSleeves = $('.added-sleeves');
    $hero = $('.hero');
    $topBanner = $('.top-banner');
  };

  var setVariables = function setVariables(options) {
    collectionHandle = options.collectionHandle;
  };

  var goToStar = function goToStar() {
    var urlSearch = window.location.search;
    var searchArr = urlSearch.slice(1, urlSearch.length).split('&');
    var searchObj = {};

    for (var i = 0; i < searchArr.length; i++) {
      var current = searchArr[i].split('=');
      searchObj[current[0]] = current[1];
    }

    if (searchObj.star) {
      var top = $('#' + searchObj.star).offset().top - 300;

      if ($(window).width() < 992) {
        top += 200;
      }

      $('html, body').animate({
        scrollTop: top
      }, 2000);
    }
  };

  var getOffsets = function getOffsets() {
    originalOffset = $addedSleeves.offset().top;
  };

  var addOrgyPrice = function addOrgyPrice(currentSleevePrice) {
    var currentOrgyPrice = Number($('.orgy-price').text());
    var updatedOrgyPrice = parseFloat(currentOrgyPrice + currentSleevePrice).toFixed(2);
    $('.orgy-price').text(updatedOrgyPrice);

    girlsSum++;
    $('.girls-sum').text(girlsSum);

    if (girlsSum == 1) {
      $('.orgy-girls').addClass('girls-active');
      $('.orgy-total').css('display', 'flex');
      $('.mobile-add-to-cart').show();
    }
  };

  var subtractOrgyPrice = function subtractOrgyPrice(currentSleevePrice) {
    var currentOrgyPrice = Number($('.orgy-price').text());
    var updatedOrgyPrice = parseFloat(currentOrgyPrice - currentSleevePrice).toFixed(2);
    $('.orgy-price').text(updatedOrgyPrice);

    girlsSum--;
    $('.girls-sum').text(girlsSum);

    if (girlsSum == 0) {
      $('.orgy-girls').removeClass('girls-active open');
      $('.orgy-total').hide();
      if ($(window).width() <= 992) {
        $('.orgy-list, .mobile-add-to-cart').hide();
      }
    }
  };

  var selectSleeve = function selectSleeve(selectedSleeve) {
    $(selectedSleeve).addClass('orgy-sleeve-selected');
    $(selectedSleeve).clone().prependTo('.added-sleeves ul');
  };

  var deselectSleeve = function deselectSleeve(selectedSleeve) {
    var variantId = $(selectedSleeve).attr('data-orgy-sleeve-id');

    $(selectedSleeve).removeClass('orgy-sleeve-selected');
    $('.added-sleeves ul').find('li[data-orgy-sleeve-id="' + variantId + '"]').remove();
  };

  var multiBinds = function multiBinds() {
    $(window).on('load resize', function () {
      var width = $(window).width();

      if (width <= breakpoint && isMobile === 0) {
        $('.added-sleeves').insertAfter('.products');
        isMobile = 1;
      } else {
        if (width > breakpoint && isMobile === 1) {
          isMobile = 0;
          $('.added-sleeves').insertAfter('.hero');
        }
      }
    });
  };

  var scrollBinds = function scrollBinds() {
    $(window).on('scroll', function () {
      if ($(this).width() > 991) {
        var top = $(this).scrollTop();
        var mainNavHeightDesktop = $mainNavDesktop.height();

        if ($topBanner.length > 0) {
          mainNavHeightDesktop += $topBanner.outerHeight();
          top += $topBanner.outerHeight();
        }

        if (top >= originalOffset - $addedSleeves.height() / 2) {
          $addedSleeves.css({
            position: 'fixed',
            bottom: 'inherit',
            top: mainNavHeightDesktop,
            zIndex: 10
          });
        } else {
          $addedSleeves.css({
            position: 'static',
            bottom: 0,
            top: 'inherit',
            zIndex: 10
          });
        }
      }
    });
  };

  var clickBinds = function clickBinds() {
    $('.orgy-sleeve-table li').on('click', function () {
      var $this = $(this);
      var sleevePrice = Number(parseFloat($this.attr('data-orgy-sleeve-price')).toFixed(2));

      if ($this.hasClass('orgy-sleeve-selected')) {
        deselectSleeve($this);
        subtractOrgyPrice(sleevePrice);
      } else {
        selectSleeve($this);
        addOrgyPrice(sleevePrice);
      }
    });

    $(document).on('click', '.close-sleeve', function (e) {
      e.preventDefault();
      $(this).parent().remove();
      var selectedVariant = $(this).parent().attr('data-orgy-sleeve-id');
      $('li[data-orgy-sleeve-id="' + selectedVariant + '"]').removeClass('orgy-sleeve-selected');

      subtractOrgyPrice($(this).parent().attr('data-orgy-sleeve-price'));
    });

    $('.orgy-girls').on('click', function () {
      if (girlsSum > 0) {
        $(this).toggleClass('open');
        $('.orgy-list').slideToggle();
      }
    });

    $('.add-to-cart').on('click', function () {
      var $this = $(this);

      var variant_array = [];

      $('.orgy-list li').each(function () {
        variant_array.push($(this).attr('data-orgy-sleeve-id'));
      });

      $(this).text('ADDING');
      variant_array.forEach(function (id) {
        CartJS.addItem(id, 1, {
          orgy_product: 'true'
        });
      });

      $(document).on('cart.requestComplete', function (event, cart) {
        $('.add-to-cart').text('ADD TO CART');
        variant_array = [];
      });

      if (window.Cookies.get('BVAUpsell')) {
        window.InlineCart.triggerInlineCart();
        window.Scroll.lock();
      } else {
        var title = $this.attr('data-product-upsell-title');
        var $upsellTitle = $('.js-product-upsell-title');

        if (title) {
          $upsellTitle.text(title);
        } else {
          $upsellTitle.text(window.ProductUpsell.defaultTitle);
        }
        ProductUpsell.open(collectionHandle);
      }
    });
  };

  var bindUIActions = function bindUIActions(country) {
    if (typeof country === 'undefined') {
      clickBinds();
    }
    scrollBinds();
    multiBinds();
  };

  var init = function init(options) {
    cacheDom();
    setVariables(options);
    goToStar();
    getOffsets();
    bindUIActions(options.country);
  };

  Orgy.init = init;
  Orgy.clickBinds = clickBinds;
})(window.Orgy = window.Orgy || {}, jQuery);
'use strict';

(function (Overlay, $) {
  'use strict';

  /*
   *  Dependency: <div class="overlay" data-overlay></div> in theme.liquid,
   *              components/_overlay.scss
   *
   *  Note: _overlay.scss hold the styles for the overlay container
   *  Note: .overlay has a z-index of 1000, so any modal that needs to appear on top
   *        of the overlay need to have an z-index of 1001+
   *
   *
   */

  var $dataOverlay = void 0;

  var cacheDom = function cacheDom() {
    $dataOverlay = $('[data-overlay]');
  };

  var show = function show() {
    $dataOverlay.fadeIn(300);
  };

  var hide = function hide() {
    $dataOverlay.fadeOut(300);
  };

  var bindUIActions = function bindUIActions() {
    $dataOverlay.on('click', function () {
      hide();
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  Overlay.init = init;
  Overlay.hide = hide;
  Overlay.show = show;
})(window.Overlay = window.Overlay || {}, jQuery);
'use strict';

(function (Product, $) {
  'use strict';

  var $productDescription = void 0;
  var $productDescriptionActivation = void 0;
  var $productDescriptionParagraph = void 0;
  var $modelDescriptionContainer = void 0;
  var $modelDescription = void 0;
  var $modelDescriptionToggle = void 0;
  var $modelDescriptionText = void 0;
  var $mainATC = void 0;
  var $stickyATC = void 0;

  var cacheDom = function cacheDom() {
    $productDescription = $('.wysiwyg-desktop-only .main-product-description');
    $productDescriptionActivation = $('.product-description-activation');
    $productDescriptionParagraph = $productDescription.find('p');
    $modelDescriptionContainer = $('.js-wysiwyg-container');
    $modelDescription = $modelDescriptionContainer.find('.js-wysiwyg-expand');
    $modelDescriptionToggle = $modelDescriptionContainer.find('.js-wysiwyg-toggle');
    $modelDescriptionText = $modelDescriptionContainer.find('.js-wysiwyg-paragraphs');
    $mainATC = $('.product-add .button-container');
    $stickyATC = $('.js-sticky-add-to-cart');
  };

  var toggleDescription = function toggleDescription() {
    var paragraphHeight = $productDescriptionParagraph.height();

    if ($productDescription.attr('data-description-toggled') === 'false') {
      $productDescription.css('max-height', paragraphHeight + 'px');
      $productDescriptionActivation.text('Read Less');
      $productDescription.attr('data-description-toggled', 'true');
    } else {
      $productDescription.css('max-height', '95px');
      $productDescriptionActivation.text('Read More');
      $productDescription.attr('data-description-toggled', 'false');
    }
  };

  var bindUIActions = function bindUIActions() {
    $productDescriptionActivation.on('click', function (event) {
      event.preventDefault();
      toggleDescription();
    });

    $(window).on('scroll', function () {
      if ($(window).innerWidth >= 991 && $mainATC.offset) {
        var mainATCTop = $mainATC.offset().top;
        var mainATCBottom = mainATCTop + $mainATC.outerHeight();
        var windowScroll = $(window).scrollTop();
        var adjustedScroll = windowScroll + $('.purchase-bar').offset().top;
        if (adjustedScroll >= mainATCBottom) {
          // show stick atc
          $stickyATC.addClass('is-visible');
        } else {
          // hide sticky atc
          $stickyATC.removeClass('is-visible');
        }
      }
    });

    $modelDescriptionToggle.on('click', function toggleMobileDescription(event) {
      event.preventDefault();
      var $this = $(this);
      var paragraphHeight = $modelDescriptionText.height();

      if ($modelDescription.attr('data-description-toggled') === 'false') {
        $modelDescription.css('max-height', paragraphHeight + 'px');
        $this.text('Read Less');
        $modelDescription.attr('data-description-toggled', 'true');
      } else {
        $modelDescription.css('max-height', '200px');
        $this.text('Read More');
        $modelDescription.attr('data-description-toggled', 'false');
      }
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  Product.init = init;
})(window.Product = window.Product || {}, jQuery);
'use strict';

(function (ProductImg, $) {
  'use strict';

  var allImages = [];

  var $body = void 0;
  var $section = void 0;
  var $altImageContainer = void 0;
  var $mainImages = void 0;
  var $videoButton = void 0;
  var $video = void 0;
  var $videoButtonMobile = void 0;
  var $videoMobile = void 0;
  var $videoMobileClose = void 0;
  var $videoAltImage = void 0;
  var $slider = void 0;

  var cacheDom = function cacheDom() {
    $body = $('body');
    $section = $('.product-alt-section');
    $altImageContainer = $section.find('.product-alt-item-image').not('.js-product-alt-item-video');
    $mainImages = $('.main-product-image');
    $videoButton = $('.js-product-video-button');
    $video = $('.js-product-video');
    $videoButtonMobile = $('.js-product-video-button--mobile');
    $videoMobile = $('.js-product-video-mobile');
    $videoMobileClose = $('.js-product-video-mobile-close');
    $videoAltImage = $section.find('.js-product-alt-item-video');
    $slider = $('.slider');
  };

  var change = function change($this, direction) {
    var $imgTag = $this.parent().find('img');
    var currentIndex = parseInt($this.parent().find('img').attr('data-current-index'), 10);
    var indexes = setImageIndexes(currentIndex, direction);

    changeImage($imgTag, indexes);
  };

  var show = function show() {
    $('#product-modal').fadeIn(300).css('display', 'flex');
    window.Scroll.lock();
  };

  var itemIndexInArray = function itemIndexInArray(arr, item) {
    return arr.indexOf(item);
  };

  var playVideo = function playVideo($this, $currentVideo) {
    $this.hide();
    $currentVideo.fadeIn()[0].play();
  };

  var stopVideo = function stopVideo($button, $currentVideo) {
    $button.fadeIn();
    $currentVideo.fadeOut()[0].pause();
  };

  var bindUIActions = function bindUIActions() {
    $altImageContainer.on('click', function swapMainImage() {
      var index = $(this).attr('data-index');

      $mainImages.hide(0).css('opacity', 1);

      $mainImages.each(function showCorrectImage() {
        if ($(this).attr('data-index') === index) {
          $(this).fadeIn();
        }
      });

      $video.fadeOut()[0].pause();
      $videoButton.fadeIn();
    });

    $videoButton.on('click', function () {
      playVideo($(this), $video);
      $mainImages.css('opacity', 0);
    });

    $videoButtonMobile.on('click', function () {
      playVideo($(this).parents('.product-video-image-container--mobile'), $videoMobile);
      $slider.css('opacity', 0);
    });

    $videoMobile.on('pause', function () {
      $(this).fadeOut()[0].pause();
      $videoButtonMobile.parents('.product-video-image-container--mobile').fadeIn();
      $slider.css('opacity', 1);
    });

    $videoAltImage.on('click', function () {
      playVideo($videoButton, $video);
      $mainImages.css('opacity', 0);
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  ProductImg.init = init;
})(window.ProductImg = window.ProductImg || {}, jQuery);
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (ProductBuilder, $) {
  'use strict';

  var $dom = {};
  var radix = 10;
  var purchase = {};
  var localEvents = void 0;
  var currentStep = 1;

  var cacheDom = function cacheDom() {
    $dom.byo = $('.js-byo');
    $dom.step = $dom.byo.find('.js-byo-step');
    $dom.sideStep = $dom.byo.find('.js-byo-side-step');
    $dom.addToCart = $dom.byo.find('.js-byo-add-to-cart');
    $dom.back = $dom.byo.find('.js-byo-back');
    $dom.caseImage = $dom.byo.find('.js-byo-case-image');
    $dom.caseSelector = $dom.byo.find('.js-byo-case-selector');
    $dom.orificeImage = $dom.byo.find('.js-byo-orifice-image');
    $dom.orificeSelector = $dom.byo.find('.js-byo-orifice-selector');
    $dom.textureImage = $dom.byo.find('.js-byo-texture-image');
    $dom.accessoryImage = $dom.byo.find('.js-byo-accessory-image');
    $dom.textureSelector = $dom.byo.find('.js-byo-texture-selector');
    $dom.accessorySelector = $dom.byo.find('.js-byo-accessory-selector');
    $dom.nextStep = $dom.byo.find('.js-byo-next-step');
    $dom.productView = $dom.byo.find('.js-byo-product-view');
    $dom.checkmark = $dom.byo.find('.js-byo-checkmark');
    $dom.startOver = $dom.byo.find('.js-start-over');
    $dom.step5 = $dom.byo.find('.js-byo-side-step-5');
    $dom.step5Header = $dom.byo.find('.js-byo-header-step-5');
    $dom.step5Block = $dom.byo.find('.js-byo-build-block-step-5');
    $dom.mobileNextStep = $dom.byo.find('.js-byo-mobile-next-step');
    $dom.mobileSlider = $dom.byo.find('.js-mobile-build-slider');
    $dom.nav = $('.js-main-navigation');
    $dom.mobileButtonContainer = $dom.byo.find('.js-byo-mobile-button-container');
    $dom.mobileButtonWrapper = $dom.mobileButtonContainer.find('.js-byo-mobile-button-wrapper');
    $dom.buildContainer = $dom.byo.find('.js-byo-build-container');
    $dom.topBar = $dom.byo.find('.js-byo-top-bar');
    $dom.globalTopBanner = $('.top-banner');
    $dom.topBarText = $dom.byo.find('.js-byo-top-bar-text');
    $dom.stepExplanation = $dom.byo.find('.js-byo-step-explanation');
    $dom.sensationEntry = $dom.byo.find('.js-byo-step-explanation-sensation');
    $dom.bestSeller = $dom.byo.find('.js-byo-sensation-best-seller');
    $dom.mobileStartOver = $dom.byo.find('.js-byo-mobile-start-over');
    $dom.price = $dom.byo.find('.js-byo-price');
    $dom.accessoryImageContainer = $dom.byo.find('.js-byo-accessory-view');
    $dom.explanationSelectionText = $dom.byo.find('.js-step-explanation-selection-text');
    $dom.accessoryExplanationContainer = $dom.byo.find('.js-byo-explanation-accessory-container');
    $dom.accessoryBtn = $dom.byo.find('.js-byo-accessory-btn');
    $dom.setStep = $dom.byo.find('.js-byo-set-step');
    $dom.step5text = $dom.byo.find('.js-byo-build-name-step-5-text');
    $dom.caseSideImage = $dom.byo.find('.js-byo-case-side-image');
    $dom.window = $(window);
    $dom.mobileTopText = $('.js-byo-mobile-top-text');
  };

  var convertCentsToDollars = function convertCentsToDollars(cents) {
    return (cents / 100.0).toFixed(2);
  };

  var adjustPage = function adjustPage() {
    var adjustPageInterval = setInterval(function () {
      if ($(window).width() < 992) {
        var windowHeight = $(window).height();
        var removableHeight = $dom.nav.outerHeight() + $dom.mobileButtonContainer.outerHeight() + $dom.buildContainer.outerHeight() + $dom.topBar.outerHeight();
        if ($('body').hasClass('holiday-body')) {
          removableHeight += $dom.globalTopBanner.outerHeight();
        }

        $dom.productView.height(windowHeight - removableHeight);

        if ($dom.mobileButtonContainer.find('.slick-initialized').length) {
          clearInterval(adjustPageInterval);
        }
      } else {
        clearInterval(adjustPageInterval);
        $dom.productView.attr('style', '');
      }
    }, 500);
  };

  var adjustPrice = function adjustPrice() {
    var priceInCents = parseInt($dom.textureSelector.first().attr('data-price'), radix);
    if (purchase.accessories && purchase.accessories.length) {
      purchase.accessories.forEach(function (item) {
        priceInCents += item.price;
      });
    }

    if (window.Geolizr && window.GeolizrAPI && window.GeolizrAPI.api) {
      $dom.price.find('[data-geolizr-price]').attr('data-geolizr-price', priceInCents);
      var currency = window.GeolizrAPI.api.getCurrency();
      window.GeolizrAPI.api.switchCurrency(currency);
    } else {
      $dom.price.text('$' + convertCentsToDollars(priceInCents));
    }
  };

  var showStepItem = function showStepItem($element, step, className) {
    $element.removeClass(className).filter('[data-step="' + step + '"]').addClass(className);
  };

  var renderStep = function renderStep(step) {
    var stepToUse = step || currentStep;
    var view = void 0;
    if (stepToUse === 3) {
      view = 'texture';
    } else if (stepToUse === 4) {
      view = 'accessory';
    } else {
      view = 'orifice';
    }

    if (stepToUse === 5) {
      $dom.mobileStartOver.removeClass('hidden');
      $dom.addToCart.addClass('clickable');
    } else {
      $dom.mobileStartOver.addClass('hidden');
    }
    showStepItem($dom.sideStep, stepToUse, 'visible');
    $dom.productView.removeClass('visible').filter('[data-product-view="' + view + '"]').addClass('visible');
    showStepItem($dom.step, stepToUse, 'current');
    showStepItem($dom.mobileNextStep, stepToUse, 'visible');
    showStepItem($dom.topBarText, stepToUse, 'visible');
    showStepItem($dom.stepExplanation, stepToUse, 'visible');
    $dom.mobileButtonWrapper.hide().filter('[data-step="' + stepToUse + '"]').show().css('display', 'flex');
    $dom.mobileTopText.hide().filter('[data-step="' + step + '"]').show();;
    localEvents.emit('stepChangeComplete');
  };

  var decrimentStep = function decrimentStep() {
    currentStep -= 1;
    if (currentStep < 1) {
      currentStep = 1;
    }
    localEvents.emit('stepChange', currentStep);
  };

  var incrementStep = function incrementStep() {
    currentStep += 1;
    if (currentStep > 5) {
      currentStep = 5;
    }
    localEvents.emit('stepChange', currentStep);
  };

  var setStep = function setStep(step) {
    currentStep = step;
    localEvents.emit('stepChange', currentStep);
  };

  var selectCase = function selectCase(fCase, imageUrl) {
    $dom.caseImage.removeClass('visible').filter('[data-case="' + fCase + '"]').addClass('visible');
    $dom.caseSideImage.removeClass('visible').filter('[data-case="' + fCase + '"]').addClass('visible');
    purchase.case = purchase.case || {};
    purchase.case.value = fCase;
    purchase.case.imageUrl = imageUrl;
  };

  var selectOrifice = function selectOrifice(orifice, imageUrl) {
    $dom.orificeImage.removeClass('visible').filter('[data-orifice="' + orifice + '"]').addClass('visible');
    purchase.orifice = purchase.orifice || {};
    purchase.orifice.value = orifice;
    purchase.orifice.imageUrl = imageUrl;
  };

  var selectTexture = function selectTexture(texture, variantId, imageUrl, title, bestSeller) {
    $dom.textureImage.removeClass('visible').filter('[data-texture="' + texture + '"]').addClass('visible');
    purchase.texture = purchase.texture || {};
    purchase.texture.value = texture;
    purchase.texture.id = variantId;
    purchase.texture.imageUrl = imageUrl;
    purchase.texture.title = title;
    $dom.sensationEntry.text(title);
    if (bestSeller) {
      $dom.bestSeller.show().css('display', 'inline');
    } else {
      $dom.bestSeller.hide();
    }
  };

  var selectAccessory = function selectAccessory(accessoryId, imageUrl, title, price, handle) {
    $dom.accessoryImage.removeClass('visible').filter('[data-accessory="' + handle + '"]').addClass('visible');
    purchase.accessories = purchase.accessories || [];
    var found = false;
    for (var i = 0; i < purchase.accessories.length; i++) {
      if (purchase.accessories[i].id === accessoryId) {
        found = true;
        break;
      }
    }
    if (!found) {
      purchase.accessories.push({
        id: accessoryId,
        imageUrl: imageUrl,
        title: title,
        price: price
      });
    } else {
      purchase.accessories = purchase.accessories.filter(function (accessory) {
        return accessory.id !== accessoryId;
      });
    }
  };

  var setSliders = function setSliders() {
    var SliderOptions = function SliderOptions() {
      _classCallCheck(this, SliderOptions);

      this.infinite = false;
      this.slidesToShow = 4;
      this.swipeToSlide = true;
      this.arrows = false;
      this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>';
      this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>';
    };

    if ($(window).width() < 992) {
      $dom.mobileSlider.filter('.slick-initialized').each(function checkLengthSetSlick() {
        if ($(this).find('.byo--build-block').not('.hidden').length > 4) {
          $(this).slick('unslick').slick(new SliderOptions());
          $(this).slick('slickUnfilter');
          $(this).slick('slickFilter', ':not(.hidden)');
        } else {
          $(this).removeClass('byo--slider').slick('unslick');
        }
      });

      $dom.mobileSlider.not('.slick-initialized').each(function checkLengthSetSlick() {
        if ($(this).find('.byo--build-block').not('.hidden').length > 4) {
          $(this).addClass('byo--slider').slick(new SliderOptions());
          $(this).slick('slickUnfilter');
          $(this).slick('slickFilter', ':not(.hidden)');
        }
      });
    } else {
      $dom.mobileSlider.filter('.slick-initialized').each(function removeInitializedState() {
        $(this).removeClass('byo--slider').slick('unslick');
      });
    }

    if (currentStep === 4) {
      var options = new SliderOptions();
      options.slidesToShow = 1;
      options.arrows = true;
      if ($dom.accessoryImageContainer.hasClass('slick-initialized')) {
        options.initialSlide = parseInt($dom.accessorySelector.filter('.slide-selected').attr('data-slide'), radix) - 1;
        $dom.accessoryImageContainer.slick('unslick').slick(options);
      } else {
        $dom.accessoryImageContainer.slick(options);
      }
    }
  };

  var toggleCheckmark = function toggleCheckmark($self) {
    if (!$self.hasClass('js-byo-accessory-selector')) {
      $self.siblings().find('.js-byo-checkmark').removeClass('active');
      $self.find('.js-byo-checkmark').addClass('active');
    } else {
      $self.find('.js-byo-checkmark').toggleClass('active');
    }
  };

  var startOver = function startOver(event) {
    if (event) {
      event.preventDefault();
    }
    delete purchase.case;
    delete purchase.orifice;
    delete purchase.texture;
    delete purchase.accessories;
    $dom.addToCart.removeClass('clickable');
    $dom.orificeImage.removeClass('visible');
    $dom.caseImage.removeClass('visible').filter('.js-byo-case-image').first().addClass('visible');
    $dom.textureImage.removeClass('visible');
    setStep(1);
    $dom.checkmark.removeClass('active');
    $dom.step.removeClass('selected');
    $dom.sensationEntry.text('');
    $dom.bestSeller.hide();
    $dom.back.addClass('hidden');
    $dom.mobileStartOver.addClass('hidden');
    $dom.nextStep.filter('[data-toggleable]').addClass('disabled');
    $dom.step5Block.filter('[data-type="accessories"]').addClass('hidden');
    $dom.explanationSelectionText.filter('[data-selected="selected"]').hide();
    $dom.explanationSelectionText.filter('[data-selected="not-selected"]').show();
    adjustPrice();
  };

  var addItemsToCart = function addItemsToCart($self) {
    if (!$self.hasClass('clickable')) {
      return false;
    }

    window.CartJS.addItem(purchase.texture.id, 1, {
      case: purchase.case.value,
      orifice: purchase.orifice.value,
      texture: purchase.texture.value
    });

    if (purchase.accessories) {
      purchase.accessories.forEach(function (accessory) {
        window.CartJS.addItem(accessory.id, 1, {}, {});
      });
    }

    window.InlineCart.triggerInlineCart();
    return true;
  };

  var setStepSelectedState = function setStepSelectedState(step, isAccessories) {
    if (!isAccessories) {
      $dom.step.filter('[data-step="' + step + '"]').addClass('selected');
      $dom.mobileNextStep.filter('[data-step="' + step + '"]').removeClass('unclickable');
      $dom.nextStep.filter('[data-step="' + step + '"]').removeClass('disabled');
      return true;
    }

    if (purchase.accessories.length) {
      $dom.step.filter('[data-step="' + step + '"]').addClass('selected');
      $dom.accessoryBtn.removeClass('no-accessory');
    } else {
      $dom.step.filter('[data-step="' + step + '"]').removeClass('selected');
      $dom.accessoryBtn.addClass('no-accessory');
    }
    return true;
  };

  var setStep5Block = function setStep5Block(type, imageUrl) {
    if (type !== 'accessory') {
      $dom.step5Block.filter('[data-type="' + type + '"]').removeClass('hidden').find('.js-byo-build-image-step-5').attr('src', imageUrl);
      return true;
    }

    return true;
  };

  var setStep5Accessories = function setStep5Accessories() {
    $dom.step5Block.filter('[data-type="accessories"]').addClass('hidden');
    purchase.accessories.forEach(function (item) {
      $dom.step5Block.filter('[data-type="accessories"]').filter('[data-variant-id="' + item.id + '"]').removeClass('hidden');
    });
  };

  var setStep5 = function setStep5() {
    var headerText = '';
    if (purchase.case) {
      headerText += purchase.case.value + ' case';
      setStep5Block('case', purchase.case.imageUrl);
    }

    if (purchase.orifice) {
      headerText += headerText.length ? ' - ' + purchase.orifice.value : purchase.orifice;
      setStep5Block('orifice', purchase.orifice.imageUrl);
    }

    if (purchase.texture) {
      headerText += headerText.length ? ' - ' + purchase.texture.value : purchase.texture.value;
      setStep5Block('texture', purchase.texture.imageUrl);
    }

    if (purchase.accessories) {
      purchase.accessories.forEach(function (accessory) {
        headerText += headerText.length ? ' - ' + accessory.title : accessory.title;
      });
      setStep5Accessories();
    }

    $dom.byo.find('.js-byo-header-insertion-step-5').text(headerText);
  };

  var setSlide = function setSlide(slide) {
    var goTo = parseInt(slide, radix) - 1;
    $dom.accessoryImageContainer.slick('slickGoTo', goTo);
  };

  var setLocalEvents = function setLocalEvents() {
    localEvents = new window.PubSub.Create('ProductBuilder');
    localEvents.on('stepChange', renderStep);
    localEvents.on('stepChangeComplete', setSliders);
  };

  var setExplanationText = function setExplanationText(filter, value) {
    var $text = $dom.explanationSelectionText.filter('[data-type="' + filter + '"]');
    $text.filter('[data-selected="not-selected"]').hide();
    $text.filter('[data-selected="selected"]').find('.js-step-explanation-insertion').text(value);
    $text.filter('[data-selected="selected"]').show();
  };

  var bindUIActions = function bindUIActions() {
    $dom.back.on('click', decrimentStep);

    $dom.caseSelector.on('click', function selectCaseOnClick(event) {
      event.preventDefault();
      var $self = $(this);
      var fCase = $self.attr('data-case');
      var step = $self.attr('data-step');
      var imageUrl = $self.attr('data-image');
      selectCase(fCase, imageUrl);
      toggleCheckmark($self);
      setStepSelectedState(step);
      setStep5();
      setExplanationText('case', fCase);
      $dom.step5text.filter('[data-type="' + 'case' + '"]').text(fCase);
    });

    $dom.orificeSelector.on('click', function selectOrificeOnClick(event) {
      event.preventDefault();
      var $self = $(this);
      var orifice = $self.attr('data-orifice');
      var step = $self.attr('data-step');
      var imageUrl = $self.attr('data-image');
      selectOrifice(orifice, imageUrl);
      toggleCheckmark($self);
      setStepSelectedState(step);
      setStep5();
      setExplanationText('orifice', orifice);
      $dom.step5text.filter('[data-type="' + 'orifice' + '"]').text(orifice);
    });

    $dom.textureSelector.on('click', function selectTextureOnClick(event) {
      event.preventDefault();
      var $self = $(this);
      var texture = $self.attr('data-texture');
      var variantId = $self.attr('data-variant-id');
      var step = $self.attr('data-step');
      var imageUrl = $self.attr('data-image');
      var title = $self.attr('data-title');
      var bestSeller = $self.attr('data-best-seller');
      selectTexture(texture, variantId, imageUrl, title, bestSeller);
      toggleCheckmark($self);
      setStepSelectedState(step);
      setStep5();
      setExplanationText('texture', texture);
      $dom.step5text.filter('[data-type="' + 'texture' + '"]').text(texture);
    });

    $dom.accessorySelector.on('click', function selectAccessoryOnClick(event) {
      event.preventDefault();
      var $self = $(this);
      var variantId = $(this).attr('data-variant-id');
      var step = $self.attr('data-step');
      var imageUrl = $self.attr('data-image');
      var title = $self.attr('data-title');
      var price = parseInt($self.attr('data-price'), radix);
      var handle = $self.attr('data-handle');
      var slide = $self.attr('data-slide');
      selectAccessory(variantId, imageUrl, title, price, handle);
      toggleCheckmark($self);
      setStepSelectedState(step, true);
      setStep5();
      adjustPrice();
      setSlide(slide);
      $dom.accessoryExplanationContainer.filter('[data-handle="' + handle + '"]').find('.js-step-explanation-selection-text').toggle();
    });

    $dom.nextStep.on('click', function (event) {
      event.preventDefault();
      incrementStep();
    });

    $dom.startOver.on('click', startOver);

    $dom.addToCart.on('click', function addItemsToCartOnClick(event) {
      event.preventDefault();
      addItemsToCart($(this));
    });

    $dom.accessoryImageContainer.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $dom.accessorySelector.removeClass('slide-selected').filter('[data-slide="' + (nextSlide + 1) + '"]').addClass('slide-selected');
      $dom.accessoryExplanationContainer.hide().filter('[data-slide="' + (nextSlide + 1) + '"]').show();
    });

    $dom.setStep.on('click', function setStepOnClick(event) {
      event.preventDefault();
      var step = parseInt($(this).attr('data-step'), radix);
      setStep(step);
    });

    $dom.window.on('resize', function () {
      setSliders();
      adjustPage();
    });
  };

  var init = function init() {
    cacheDom();
    setLocalEvents();
    bindUIActions();
    setSliders();
    adjustPage();
  };

  ProductBuilder.init = init;
})(window.ProductBuilder = window.ProductBuilder || {}, jQuery);
'use strict';

(function (ProductCount, $) {
  'use strict';

  var API = 'https://product-hit-counter-fl.herokuapp.com/api/';

  var $countContainer = void 0;
  var $numberElement = void 0;

  var cacheDom = function cacheDom() {
    $countContainer = $('.product-count');
    $numberElement = $countContainer.find('[data-product-count]');
  };

  var accessAPI = function accessAPI(product) {
    $.ajax({
      url: API + 'count/' + product.product.id,
      dataType: 'json',
      success: function success(data) {
        if (data.length < 1) {
          createProduct(product);
        } else {
          updateProduct(product);
        }
      }
    });
  };

  var setCount = function setCount(number) {
    $numberElement.html(number).show().css('display', 'inline-block');
  };

  var getCount = function getCount(counts) {
    while (counts.length > 30) {
      counts.splice(0, 1);
    }

    var total = 0;
    for (var i = 0; i < counts.length; i++) {
      total += parseInt(counts[i].count, 10);
    }
    return total;
  };

  var createProduct = function createProduct(product) {
    $.ajax({
      url: API + 'create/' + product.product.id,
      method: 'POST',
      dataType: 'json',
      success: function success(data) {
        setCount(getCount(data.counts));
      }
    });
  };

  var updateProduct = function updateProduct(product) {
    $.ajax({
      url: API + 'update/' + product.product.id,
      method: 'POST',
      success: function success(data) {
        setCount(getCount(data[0].counts));
      }
    });
  };

  var pullProduct = function pullProduct() {
    $.ajax({
      url: window.location + '.json',
      dataType: 'json',
      success: function success(product) {
        accessAPI(product);
      }
    });
  };

  var run = function run() {
    pullProduct();
  };

  var init = function init() {
    cacheDom();
    run();
  };

  ProductCount.init = init;
})(window.ProductCount = window.ProductCount || {}, jQuery);
'use strict';

(function (ProductPornstar, $) {
  'use strict';

  var $form = void 0;
  var $orificeContainer = void 0;
  var $orificeSelect = void 0;
  var $orificeImage = void 0;
  var $textureSelect = void 0;
  var $playButton = void 0;
  var $videoContainer = void 0;
  var $video = void 0;
  var $addToCart = void 0;
  var $texture = void 0;
  var $textureTitle = void 0;
  var $orificeTitle = void 0;
  var $videoClose = void 0;
  var $orificeBest = void 0;
  var $textureBest = void 0;
  var $purchaseBarVariant = void 0;
  var $description = void 0;

  var cacheDom = function cacheDom() {
    $form = $('.js-product-selection-form');
    $orificeContainer = $form.find('.js-orifice-container');
    $orificeSelect = $form.find('.js-orifice-select');
    $orificeImage = $('.js-orifice-image');
    $textureSelect = $form.find('.js-texture-select');
    $playButton = $('.js-pornstar-play-button');
    $videoContainer = $('.js-pornstar-video-container');
    $video = $('.js-product-pornstar-video');
    $addToCart = $('.js-pornstar-button');
    $texture = $('.js-texture-image');
    $textureTitle = $('.js-texture-title');
    $orificeTitle = $form.find('.js-orifice-title');
    $videoClose = $('.js-pornstar-video-close');
    $orificeBest = $('.js-product-high-seller');
    $textureBest = $('.js-texture-best-seller');
    $purchaseBarVariant = $('.js-purchase-bar-variant');
    $description = $('.js-description');
  };

  var setActiveState = function setActiveState($this, activeClass) {
    if (!$this.hasClass(activeClass)) {
      $this.siblings('.' + activeClass).removeClass(activeClass);
      $this.addClass(activeClass);
    }
  };

  var setActiveDescription = function setActiveDescription(index) {
    if (parseInt(index) <= $description.length) {
      $description.each(function (i) {
        if (i + 1 === parseInt(index)) {
          $description.removeClass('active');
          if ($(this).text().trim().length > 0) {
            $(this).addClass('active');
          } else {
            $description.first().addClass('active');
          }
        }
      });
    } else {
      $description.removeClass('active');
      $description.first().addClass('active');
    }
  };

  var bindUIActions = function bindUIActions() {
    $orificeSelect.on('click', function selectOrifice() {
      var $this = $(this);
      var showingClass = 'showing';
      var orificeActive = 'active';
      var orifice = $this.attr('data-orifice');
      var orificeContainerClass = 'active-orifice-container';

      var $image = void 0;
      var $container = void 0;
      var imageSet = false;
      var containerSet = false;
      var $firstVariantInContainer = void 0;
      var textureSet = false;
      var firstOrifice = false;

      setActiveState($this, 'product-orifice-side-view--active');

      $orificeTitle.text(orifice);

      $orificeImage.each(function setOrificeImage(index) {
        if ($(this).attr('data-orifice') === orifice && !imageSet) {
          if (index === 0) {
            firstOrifice = true;
          }
          $image = $(this);
          imageSet = true;
        }
      });

      if (firstOrifice) {
        $orificeBest.show();
        $textureBest.show();
      } else {
        $orificeBest.hide();
        $textureBest.hide();
      }

      $orificeImage.removeClass(orificeActive);
      $image.addClass(orificeActive);

      if ($video.length) {
        $video[0].pause();
        $videoContainer.removeClass(showingClass);
        $playButton.fadeIn();
      }

      $orificeContainer.each(function showContainer() {
        if ($(this).attr('data-orifice') === orifice && !containerSet) {
          $container = $(this);
          $firstVariantInContainer = $container.find('.js-texture-select').first();
          containerSet = true;
        }
      });
      $orificeContainer.removeClass(orificeContainerClass);
      $container.addClass(orificeContainerClass);

      $textureTitle.text($firstVariantInContainer.attr('data-variant-name-actual'));

      setActiveState($firstVariantInContainer, 'product-texture-side-view--active');
      setActiveDescription($firstVariantInContainer.attr('data-index'));
      $addToCart.attr('data-variant-id', $firstVariantInContainer.attr('data-variant-id'));
      $purchaseBarVariant.text($firstVariantInContainer.attr('data-variant-name-actual'));
      $texture.removeClass('active');
      $texture.each(function setTextureImageOnOrificeChange() {
        if ($firstVariantInContainer.attr('data-variant-name') === $(this).attr('data-variant-name') && !textureSet) {
          textureSet = true;
          $(this).addClass('active');
        }
      });
    });

    $textureSelect.on('click', function selectTexture() {
      var $this = $(this);
      var variantId = $this.attr('data-variant-id');
      var variantHandle = $this.attr('data-variant-name');
      var variantName = $this.attr('data-variant-name-actual');
      var active = 'active';
      var variantNospace = variantHandle.replace(/-/g, '');

      var variantSet = false;
      var $currentTexture = void 0;
      var firstOrifice = false;
      var firstTexture = false;

      $orificeSelect.each(function (index) {
        var $this = $(this);
        if (index === 0 && $this.hasClass('product-orifice-side-view--active')) {
          firstOrifice = true;
        }
      });

      $textureSelect.each(function (index) {
        var $current = $(this);
        if (index === 0 && $current.attr('data-variant-name') === $this.attr('data-variant-name')) {
          firstTexture = true;
        }
      });

      if (firstOrifice && firstTexture) {
        $textureBest.show();
      } else {
        $textureBest.hide();
      }

      setActiveState($this, 'product-texture-side-view--active');
      $textureTitle.text(variantName);
      $purchaseBarVariant.text(variantName);

      $addToCart.attr('data-variant-id', variantId);

      $texture.each(function setTextureImage() {
        if ($(this).attr('data-variant-name') === variantNospace && !variantSet) {
          variantSet = true;
          $currentTexture = $(this);
        }
      });

      $texture.removeClass(active);
      $currentTexture.addClass(active);
      setActiveDescription($this.attr('data-index'));
    });

    $playButton.on('click', function playVideo() {
      var $this = $(this);
      var showingClass = 'showing';
      $this.fadeOut();

      $videoContainer.addClass(showingClass);
      $video[0].play();
    });

    $videoClose.on('click', function closeVideo() {
      $video[0].pause();
      $videoContainer.removeClass('showing');
      $playButton.fadeIn();
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  ProductPornstar.init = init;
})(window.ProductPornstar = window.ProductPornstar || {}, jQuery);
'use strict';

(function (ProductUpsell, $) {
  'use strict';

  var sliderOptions = {
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    mobileFirst: true,
    arrows: false,
    responsive: [{
      breakpoint: 992,
      settings: 'unslick'
    }]
  };
  var flGreen = '#80d93d';
  var defaultTitle = 'Other products you may be interested in';

  var $window = void 0;
  var $productUpsell = void 0;
  var $close = void 0;
  var $overlay = void 0;
  var $submit = void 0;
  var $addToCart = void 0;
  var $insertionPoint = void 0;
  var shopUrl = void 0;
  var $upsellTitle = void 0;

  var cacheDom = function cacheDom() {
    $window = $(window);
    $productUpsell = $('.js-product-upsell');
    $close = $productUpsell.find('.js-product-upsell-close');
    $overlay = $productUpsell.find('.js-product-upsell-overlay');
    $submit = $productUpsell.find('.js-product-upsell-button');
    $insertionPoint = $productUpsell.find('.js-product-insertion');
    $upsellTitle = $productUpsell.find('.js-product-upsell-title');
    $addToCart = $('[data-add-to-cart]');
  };

  var variableSetup = function variableSetup(url) {
    shopUrl = url;
  };

  var showAdded = function showAdded($this) {
    $this.text('Added!').attr('disabled', 'disabled').css({
      'background-image': 'none',
      'background-color': flGreen,
      cursor: 'default'
    });
  };

  var createSlider = function createSlider() {
    $('.js-upsell-slider').slick(sliderOptions);
  };

  var setCookie = function setCookie() {
    var amountOfMinutes = 5;
    var minutesFromNow = new Date(new Date().getTime() + amountOfMinutes * 60 * 1000);
    window.Cookies.set('BVAUpsell', 'true', {
      expires: minutesFromNow
    });
  };

  var open = function open(collectionHandle) {
    var collectionExists = false;
    $.get('/collections/' + collectionHandle + '?view=product-upsell', function (response) {
      if (response.indexOf('js-product-upsell--product') >= 0) {
        $insertionPoint.html(response);
        collectionExists = true;
      }
    }).done(function () {
      if (collectionExists) {
        var hasCollection = false;
        if (window.collectionsInCart) {
          for (var i = 0; i < window.collectionsInCart.length; i++) {
            if (collectionHandle === window.collectionsInCart[i]) {
              hasCollection = true;
              break;
            }
          }
        }
        if (!hasCollection) {
          $productUpsell.find('.grid-item > a').removeAttr('href');
          $productUpsell.find('.grid-meta > a').removeAttr('href');
          window.TileReviews.run(shopUrl, $('.js-product-upsell .grid-meta'));
          if (window.GeolizrAPI && window.GeolizrAPI.api) {
            window.GeolizrAPI.api.switchCurrency(window.GeolizrAPI.api.getCurrency());
          }
          $productUpsell.removeClass('product-upsell-hidden');
          createSlider();
          window.Scroll.lock();
          setCookie();
        } else {
          window.InlineCart.triggerInlineCart();
          window.Scroll.lock();
        }
      } else {
        window.InlineCart.triggerInlineCart();
        window.Scroll.lock();
      }
    });
  };

  var close = function close(event) {
    event.preventDefault();
    $productUpsell.addClass('product-upsell-hidden');
    $submit.text('No Thanks').removeClass('product-upsell-button--item-added');
    window.InlineCart.triggerInlineCart();
  };

  var bindUIActions = function bindUIActions() {
    $close.on('click', close);
    $overlay.on('click', close);
    $submit.on('click', close);

    $(document).on('click', '[data-add-to-cart]', function () {
      var $this = $(this);
      var collectionHandle = $this.attr('data-product-upsell-collection-handle');
      var title = $this.attr('data-product-upsell-title');

      if (title) {
        $upsellTitle.text(title);
      } else {
        $upsellTitle.text(defaultTitle);
      }

      if (window.Cookies.get('BVAUpsell') && $productUpsell.hasClass('product-upsell-hidden')) {
        window.InlineCart.triggerInlineCart();
        window.Scroll.lock();
      } else if (!collectionHandle && $productUpsell.hasClass('product-upsell-hidden')) {
        window.InlineCart.triggerInlineCart();
        window.Scroll.lock();
      } else {
        open(collectionHandle);
      }
    });

    $productUpsell.on('click', '[data-add-to-cart]', function addUpsellItemToCart() {
      var $this = $(this);
      var variantId = $this.attr('data-variant-id');
      var quantity = 1;
      var description = $this.attr('data-hover-text');

      window.CartJS.addItem(variantId, quantity, {
        description: description
      }, {
        success: function success() {
          showAdded($this);

          if (!$submit.hasClass('product-upsell-button--item-added')) {
            $submit.text('Proceed to Cart').addClass('product-upsell-button--item-added');
          }
        },
        error: function error() {
          close();
        }
      });

      showAdded($this);
    });

    $window.on('resize', function onResize() {
      var $this = $(this);
      var $slider = $('.js-upsell-slider');
      if (!$productUpsell.hasClass('product-upsell-hidden') && $this.width() <= 992 && !$slider.hasClass('slick-initialized')) {
        $slider.slick(sliderOptions);
      }
    });
  };

  var init = function init(url) {
    cacheDom();
    variableSetup(url);
    bindUIActions();
  };

  ProductUpsell.init = init;
  ProductUpsell.open = open;

  ProductUpsell.defaultTitle = defaultTitle;
})(window.ProductUpsell = window.ProductUpsell || {}, jQuery);
'use strict';

(function (PromoBar, $) {
  'use strict';

  var $promoBar, $promoMobileSlider;

  function _cacheDom() {
    $promoBar = $('.promo-bar');
    $promoMobileSlider = $promoBar.find('.slider.mobile');
  }

  function _bindUIActions() {
    $promoMobileSlider.on('initialized.owl.carousel', function () {
      $promoBar.css('opacity', 1);
    });
  }

  function init() {
    _cacheDom();
    _bindUIActions();
  }

  PromoBar.init = init;
})(window.PromoBar = window.PromoBar || {}, jQuery);
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (PubSub) {
  var Create = function () {
    function Create(moduleName) {
      _classCallCheck(this, Create);

      this.moduleName = moduleName;
      this.events = {};
    }

    _createClass(Create, [{
      key: "on",
      value: function on(eventName, callback) {
        this.events[eventName] = this.events[eventName] || [];
        this.events[eventName].push(callback);
      }
    }, {
      key: "emit",
      value: function emit(eventName, data) {
        if (this.events[eventName]) {
          this.events[eventName].forEach(function (callback) {
            callback(data);
          });
        }
      }
    }]);

    return Create;
  }();

  PubSub.Create = Create;
})(window.PubSub = window.PubSub || {});
'use strict';

;(function (RelatedProductsSlider, $) {

  var $dom = {};

  var sliderOptions = {
    mobileFirst: true,
    nextArrow: '<div class="owl-next slick-arrow"></div>',
    prevArrow: '<div class="owl-prev slick-arrow"></div>',
    responsive: [{
      breakpoint: 992,
      settings: "unslick"
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }]
  };

  var cacheDom = function cacheDom() {
    $dom.relatedProductsSlider = $('[data-slider="related-products-slider"]');
  };

  var initSliders = function initSliders() {
    $dom.relatedProductsSlider.on('destroy', function (event, slick) {
      var carousel = $(this);
      var reinit = Debounce.wait(function () {
        if (slick.activeBreakpoint < window.innerWidth) {
          return;
        }
        carousel.addClass('is-slick-activated').removeClass('is-slick-destroyed');
        carousel.slick(slick.options);
        window.removeEventListener(reinit);
      }, 500);
      carousel.addClass('is-slick-destroyed').removeClass('is-slick-activated');
      window.addEventListener('resize', reinit);
    }).slick(sliderOptions);
  };

  RelatedProductsSlider.init = function () {
    cacheDom();
    initSliders();
  };
})(window.RelatedProductsSlider = window.RelatedProductsSlider || {}, jQuery);
'use strict';

(function (STU, $) {

  var $window = void 0;
  var $sideImage = void 0;
  var $sectionContainer = void 0;
  var $nav = void 0;
  var navHeight = void 0;
  var $header = void 0;

  var cacheDom = function cacheDom() {
    $window = $(window);
    $sideImage = $('.stu-side-image');
    $nav = $('.main-navigation');
    $header = $('.stu-hero');
    $sectionContainer = $('.stu-scroll-container');
  };

  var setNavHeight = function setNavHeight() {
    navHeight = $nav.height();
  };

  var bindUIActions = function bindUIActions() {
    $window.on('scroll', function sideScroll() {
      var scroll = $(this).scrollTop();
      var sectionTop = $sectionContainer.offset().top;
      var sectionBottom = sectionTop + $sectionContainer.height();

      if (scroll >= sectionTop - navHeight && scroll <= sectionBottom + navHeight - $window.height()) {
        $sideImage.css({
          position: 'fixed',
          top: '50%',
          bottom: 'inherit',
          transform: 'translateY(-50%)'
        });
      } else if (scroll > sectionBottom + navHeight - $window.height()) {
        $sideImage.css({
          position: 'absolute',
          transform: 'none',
          top: 'inherit',
          bottom: '150px'
        });
      } else {
        $sideImage.css({
          position: 'absolute',
          top: '150px',
          bottom: 'inherit',
          transform: 'none'
        });
      }
    });

    $window.on('scroll', function parallax() {
      var $image = $header.find('.stu-hero-image');
      var scroll = $(this).scrollTop();
      if ($header.height() > $(this).scrollTop()) {
        $image.css({
          transform: 'translate(-50%, -' + (scroll / 10 + 30) + '%)'
        });
      }
    });
  };

  var init = function init() {
    cacheDom();

    if ($window.width() > 991) {
      setNavHeight();
      bindUIActions();
    }
  };

  STU.init = init;
})(window.STU = window.STU || {}, jQuery);
'use strict';

(function (Scroll, $) {

  'use strict';

  /*
   *  Dependency: components/_scroll.scss
   *
   *
   */

  var $elements = void 0;

  var cacheDom = function cacheDom() {
    $elements = $('html, body');
  };

  var lock = function lock(menuName) {
    $elements.addClass('no-scroll');
  };

  var unlock = function unlock(menuName) {
    $elements.removeClass('no-scroll');
  };

  var init = function init() {
    cacheDom();
  };

  Scroll.init = init;
  Scroll.lock = lock;
  Scroll.unlock = unlock;
})(window.Scroll = window.Scroll || {}, jQuery);
'use strict';

(function (SiteNav, $) {
  'use strict';

  var $wrapper;
  var $item;

  var cacheDom = function cacheDom() {
    $wrapper = $('.js-nav-inner-wrapper');
    $item = $wrapper.find('.js-nav-hover-item');
  };

  var bindUIActions = function bindUIActions() {
    $item.on('mouseenter', function () {
      var $this = $(this);
      var text = $this.attr('data-text');
      var image = $this.attr('data-image');
      var href = $this.attr('data-href');
      var $parent = $this.parents('.js-nav-inner-wrapper');

      $parent.find('.js-nav-text').text(text);
      $parent.find('.js-nav-image').attr('src', image);
      $parent.find('.js-nav-link').attr('href', href);
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  SiteNav.init = init;
})(window.SiteNav = window.SiteNav || {}, jQuery);
'use strict';

(function (SmoothScroll, $) {
  'use strict';

  var options = {};
  var $fromSelector = void 0;
  var $toSelector = void 0;

  var cacheDom = function cacheDom() {
    $fromSelector = $(options.fromSelector);
    $toSelector = $(options.toSelector);
  };

  var scrollToElement = function scrollToElement() {
    var windowWidth = $(window).width();
    var extraOffset = void 0;
    if (windowWidth < options.mobileBreak) {
      extraOffset = options.mobileOffset;
    } else {
      extraOffset = options.desktopOffset;
    };

    $('html, body').animate({
      scrollTop: $toSelector.offset().top + extraOffset
    }, options.scrollSpeed);
  };

  var setOptions = function setOptions(userOptions) {
    options.fromSelector = userOptions.fromSelector || '.scroll-from';
    options.toSelector = userOptions.toSelector || '.scroll-to';
    options.desktopOffset = userOptions.desktopOffset || 0;
    options.mobileOffset = userOptions.mobileOffset || 0;
    options.scrollSpeed = userOptions.scrollSpeed || 1000;
    options.mobileBreak = userOptions.mobileBreak || 992;
  };

  var bindUIActions = function bindUIActions() {
    $fromSelector.on('click', scrollToElement);

    $('[scroll-to]').on('click', function () {
      var scrollTo = $(this).attr('scroll-to');
      var $scrollTarget = $('[scroll-position="' + scrollTo + '"]');
      var scrollOffset = $scrollTarget.offset().top - $('.main-navigation').outerHeight();
      $('html, body').animate({ scrollTop: scrollOffset }, options.scrollSpeed);
    });
  };

  var scroll = function scroll(userOptions) {
    setOptions(userOptions);
    cacheDom();
    bindUIActions();
  };

  SmoothScroll.scroll = scroll;
})(window.SmoothScroll = window.SmoothScroll || {}, jQuery);
'use strict';

(function (SocialProof, $) {
  'use strict';

  var $slider = void 0;
  var $logoLinks = void 0;

  var cacheDom = function cacheDom() {
    $slider = $('.social-proof-sliderr');
    $logoLinks = $('.social-proof-logo');
  };

  var bindUIActions = function bindUIActions() {
    $slider.on('initialized.owl.carousel', function () {
      $($logoLinks[0]).addClass('active');
    });

    $slider.on('changed.owl.carousel', function (event) {
      var index = event.page.index;
      $logoLinks.removeClass('active');
      $($logoLinks[index]).addClass('active');
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  SocialProof.init = init;
})(window.SocialProof = window.SocialProof || {}, jQuery);
'use strict';

(function (SocialSharing, $) {
  'use strict';

  /* eslint-disable */

  var injectPinterestScript = function injectPinterestScript() {
    var d = document;
    var f = d.getElementsByTagName('SCRIPT')[0],
        p = d.createElement('SCRIPT');
    p.type = 'text/javascript';
    p.async = true;
    p.src = '//assets.pinterest.com/js/pinit.js';
    f.parentNode.insertBefore(p, f);
  };
  /* eslint-enable */

  var bindUIActions = function bindUIActions() {
    $(document).on('click', '.social-sharing', function run(event) {
      event.preventDefault();
      var articleURL = '';
      var url = void 0;
      var imgURL = void 0;
      var description = void 0;

      if (location.pathname === '/blogs/news/' || location.pathname === '/blogs/news') {
        articleURL = 'http://' + location.hostname + $(this).data('share-url');
      } else {
        articleURL = window.location.href;
      }

      switch ($(this).data('network')) {
        case 'facebook':
          window.open('http://www.facebook.com/sharer/sharer.php?u=' + articleURL, 'Facebook', 'width=600, height=400, scrollbars=no');
          break;
        case 'twitter':
          window.open('http://www.twitter.com/intent/tweet?url=' + encodeURIComponent(articleURL), 'Tweet', 'width=600, height=400, scrollbars=no');
          break;
        case 'pinterest':
          url = encodeURIComponent(articleURL);
          imgURL = encodeURIComponent($('.product-photo-thumb.slick-active img').attr('src'));
          description = $('.product-description').text();
          window.open('http://pinterest.com/pin/create/button/?url=' + url + '&media=' + imgURL + '&description=' + description, 'Pinterest', 'width=600, height=400, scrollbars=no');
          break;
        case 'google-plus':
          window.open('https://plus.google.com/share?url=' + encodeURIComponent(articleURL), 'GooglePlus', 'width=680, height=450, scrollbars=no');
      }
    });
  };

  var init = function init() {
    bindUIActions();
    injectPinterestScript();
  };

  SocialSharing.init = init;
})(window.SocialSharing = window.SocialSharing || {}, jQuery);
'use strict';

(function (Sort, $) {
  'use strict';

  Shopify.queryParams = {};

  var $sortList = void 0;
  var $sortItems = void 0;
  var $activate = void 0;
  var $header = void 0;

  var cacheDom = function cacheDom() {
    $sortList = $('.js-sort-list');
    $sortItems = $('.js-sort-item');
    $activate = $('.js-sort-activate');
    $header = $('.js-sale-aside-header-mobile');
  };

  var searchQuery = function searchQuery() {
    var itemSet = false;
    var setActive = false;
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          if (Shopify.queryParams.sort_by) {
            setActive = true;
          }
        }
      }
    }
    if (setActive) {
      var itemName = Shopify.queryParams.sort_by || '';
      $sortItems.not('.js-sort-bar-item').each(function highlightItem() {
        var $this = $(this);
        var linkName = $this.attr('data-search');
        if (!itemSet && linkName.toLowerCase() === itemName.toLowerCase()) {
          itemSet = true;
          $this.parent('li').addClass('highlight');
          $header.text($this.text());
        }
      });
    }
  };

  var bindUIActions = function bindUIActions() {
    $sortItems.on('click', function sortItems(event) {
      event.preventDefault();
      var $this = $(this);
      var linkName = $this.attr('data-search');
      Shopify.queryParams.sort_by = linkName;
      location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
    });

    $activate.on('click', function () {
      if ($(window).width() < 992) {
        $sortList.slideToggle();
      }
    });
  };

  var init = function init(sortValue) {
    cacheDom();
    searchQuery();
    bindUIActions();
  };

  Sort.init = init;
})(window.Sort = window.Sort || {}, jQuery);
'use strict';

(function (SortBar, $) {
  'use strict';

  var $sortingBar = void 0;
  var $sortingMenu = void 0;
  var $activate = void 0;
  var $sortList = void 0;
  var $sortItems = void 0;
  var $sidebar = void 0;
  var $sortingMethod = void 0;
  var $shopTitle = void 0;

  var cacheDom = function cacheDom() {
    $sortingBar = $('.js-sorting-bar');
    $sortingMenu = $('.js-sort-menu');
    $activate = $('.js-sort-bar-activate');
    $sortList = $sortingMenu.find('.js-sort-bar-list');
    $sortItems = $sortingMenu.find('.js-sort-bar-item');
    $sidebar = $('.js-star-sidebar');
    $sortingMethod = $('.js-sorting-method');
    $shopTitle = $('.js-shop-title');
  };

  var scroll = function scroll() {
    var addOn = $('.main-navigation').height();
    $('html, body').animate({
      scrollTop: $sortingBar.offset().top - addOn
    });
  };

  var rotate = function rotate($item, rotateClass) {
    if ($item.hasClass(rotateClass)) {
      $item.removeClass(rotateClass);
    } else {
      $item.addClass(rotateClass);
    }
  };

  var setActive = function setActive() {
    var queries = window.location.search.slice(1, window.location.search.length).split('&');
    var queryObj = {};
    var activeClass = 'active';
    for (var i = 0; i < queries.length; i++) {
      var queryArray = queries[i].split('=');
      queryObj[queryArray[0]] = queryArray[1];
    }
    $sortItems.removeClass(activeClass).each(function () {
      var $this = $(this);
      if ($this.attr('data-search') === queryObj.sort_by) {
        $this.addClass(activeClass);
        $sortingMethod.text($this.text());
      }
    });

    if (!$sortItems.hasClass(activeClass)) {
      $($sortItems[0]).addClass(activeClass);
      $sortingMethod.text($($sortItems[0]).text());
    }
  };

  var bindUIActions = function bindUIActions() {
    $activate.on('click', function () {
      var $this = $(this);
      if ($(window).width() < 992) {
        scroll();
        $sidebar.hide();
      }
      $('.js-star-filtering .js-sorting-caret').removeClass('sorting-caret--rotate');
      $shopTitle.removeClass('active');
      rotate($this.find('.js-sorting-caret'), 'sorting-caret--rotate');
      $sortList.slideToggle();
      $sortingMethod.toggleClass('active');
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
    setActive();
  };

  SortBar.init = init;
  SortBar.scroll = scroll;
  SortBar.rotate = rotate;
})(window.SortBar = window.SortBar || {}, jQuery);
'use strict';

(function (StarFilter, $) {
  'use strict';

  var activeClass = 'star-visible';
  var $container = void 0;
  var $search = void 0;
  var $names = void 0;
  var $loadMore = void 0;
  var $header = void 0;
  var $filtering = void 0;
  var $sidebar = void 0;
  var $sortMenu = void 0;
  var showingUpdateAmount = 4;
  var showing = showingUpdateAmount;
  var list = [];
  var allLoaded = false;

  var cacheDom = function cacheDom() {
    $container = $('.js-star-search');
    $search = $container.find('.js-star-input');
    $names = $('.js-star-search-item');
    $loadMore = $('.js-star-load-more');
    $header = $('.js-sidebar-header');
    $filtering = $('.js-star-filtering');
    $sidebar = $('.js-star-sidebar');
    $sortMenu = $('.js-sort-bar-list');
  };

  var updateShowingAmount = function updateShowingAmount(amount) {
    if (!amount) {
      var nameSize = list.length || $names.length;
      if (nameSize - showing > showing) {
        showing += showingUpdateAmount;
        return false;
      }
      showing += nameSize % showingUpdateAmount;
      return true;
    }
    showing = amount;
  };

  var clearSearch = function clearSearch() {
    $search.val('');
  };

  var hideLoad = function hideLoad(remove) {
    $loadMore.parent().hide();
    if (remove) {
      $loadMore.parent().remove();
    }
  };

  var showLoad = function showLoad() {
    if (!allLoaded) {
      $loadMore.parent().show();
    }
  };

  var initMobile = function initMobile() {
    updateShowingAmount($names.length);
    $names.each(function () {
      var $this = $(this);
      if (!$this.hasClass(activeClass)) {
        $this.addClass(activeClass);
      }
    });
    hideLoad(true);
  };

  var bindUIActions = function bindUIActions() {
    $search.on('keyup', function search() {
      var $this = $(this);
      var query = new RegExp($this.val().trim().toLowerCase());
      list = [];
      var size = showing;
      if (query) {
        $names.each(function checkForMatch() {
          var $this = $(this);
          var name = $this[0].dataset.starSearch;
          if (query.test(name)) {
            list.push($this);
          }
        });
      }
      size = list.length < size && list.length > 0 ? list.length : size;
      if (size < showing) {
        hideLoad();
      } else {
        showLoad();
      }
      $names.removeClass(activeClass);
      if (list.length > 0) {
        for (var i = 0; i < size; i++) {
          $(list[i]).addClass(activeClass);
        }
      } else {
        var stopAdding = false;
        $names.each(function addActive(index) {
          if (allLoaded) {
            $(this).addClass(activeClass);
          } else {
            if (!stopAdding) {
              $(this).addClass(activeClass);
              if (index === size - 1) {
                stopAdding = true;
              }
            }
          }
        });
      }
    });

    $loadMore.on('click', function () {
      allLoaded = true;
      hideLoad(true);
      updateShowingAmount($names.length);
      if (list.length) {
        for (var i = 0; i < list.length; i++) {
          $(list[i]).addClass(activeClass);
        }
      } else {
        $names.each(function (index) {
          if (index < showing) {
            $(this).addClass(activeClass);
          }
        });
      }
    });

    $header.on('click', function toggle() {
      var $this = $(this);

      if ($this.hasClass('active')) {
        $this.removeClass('active');
      } else {
        $this.addClass('active');
      }

      SortBar.rotate($this.find('.js-sidebar-caret'), 'sidebar-caret--rotate');
      if (list.length > 0 && list.length <= showing) {
        $this.siblings().not('.js-star-search-desktop').not($loadMore.parent()).slideToggle();
      } else {
        $this.siblings().not('.js-star-search-desktop').slideToggle();
      }
    });

    $filtering.on('click', function () {
      if ($(window).width() < 1200) {
        SortBar.scroll();
        $('.js-sort-menu .js-sorting-caret').removeClass('sorting-caret--rotate');
        SortBar.rotate($filtering.find('.js-sorting-caret'), 'sorting-caret--rotate');
      }
      $('.js-shop-title').toggleClass('active');
      $('.js-sorting-method').removeClass('active');
      $sortMenu.hide();
      $sidebar.slideToggle();
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
    if ($(window).width() < 1200) {
      initMobile();
    }
    clearSearch();
    if (showing === $names.length) {
      hideLoad();
    }
  };

  StarFilter.init = init;
})(window.StarFilter = window.StarFilter || {}, jQuery);
'use strict';

(function (TileReviews, $) {
  'use strict';

  var $productTilesMeta = void 0;

  var build = function build(data, $this) {
    var totalReviews = data.response.reviews.length;
    var totalScore = 0;
    for (var i = 0; i < totalReviews; i++) {
      totalScore += data.response.reviews[i].score;
    }
    var realTotal = 0;
    var iterator = void 0;

    if (totalReviews !== 0) {
      realTotal = totalScore / totalReviews.toFixed();
    }

    var html = '';
    html += '<div class="ratings">';
    if (totalReviews !== 0) {
      html += '<span class="star-wrap">';
      iterator = 0;
      while (iterator < 5) {
        if (realTotal >= 1) {
          html += '<span class="fa fa-star"></span>';
        } else if (realTotal <= 0) {
          html += '<span class="fa fa-star-o"></span>';
        } else {
          html += '<span class="fa fa-star fa-star-half-o"></span>';
        }
        realTotal -= 1;
        iterator += 1;
      }
      html += '</span>';
    }
    html += '<span class="count-reviews">';
    if (totalReviews === 0) {
      html += '(0 Reviews)';
    } else if (totalReviews === 1) {
      html += '(1)';
    } else {
      html += '(' + totalReviews + ')';
    }
    html += '</span>';
    html += '</div>';

    $this.prepend(html);
  };

  var cacheDom = function cacheDom() {
    $productTilesMeta = $('.grid-meta');
  };

  var run = function run(url, $elements) {
    $elements.each(function () {
      var productId = $(this).data('product-id');
      var appUrl = '//yotpo-seed-all.herokuapp.com/yotpo-fetch?shop=' + url + '&pid=' + productId;
      var that = this;

      $.ajax({
        url: appUrl,
        dataType: 'json',
        method: 'GET',

        success: function success(data) {
          build(data, $(that));
        },

        error: function error(err) {
          throw err;
        }
      });
    });
  };

  var init = function init(url) {
    cacheDom();
    console.log($productTilesMeta);
    run(url, $productTilesMeta);
  };

  TileReviews.init = init;
  TileReviews.run = run;
})(window.TileReviews = window.TileReviews || {}, jQuery);
'use strict';

(function (TopCategories, $) {
  'use strict';

  var darkenClass = 'top-categories-item--darken';
  var $window = $(window);

  var $topCategories = void 0;
  var $item = void 0;

  var cacheDom = function cacheDom() {
    $topCategories = $('.js-top-categories');
    $item = $topCategories.find('.js-top-categories-item');
  };

  var bindUIActions = function bindUIActions() {
    $item.on('mouseenter', function darken() {
      if ($window.width() > 991) {
        var $this = $(this);

        $item.not($this).addClass(darkenClass);
        $this.removeClass(darkenClass);
      }
    });

    $item.on('mouseleave', function () {
      if ($window.width() > 991) {
        $item.removeClass(darkenClass);
      }
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  TopCategories.init = init;
})(window.TopCategories = window.TopCategories || {}, jQuery);
'use strict';

(function (VStroker, $) {
  'use strict';

  var sliderOptions = {
    autoplay: true,
    autoplaySpeed: 1000,
    scrollSpeed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    prevArrow: '<button class="review-slider-button slider--prev flex-row"><i class="fa fa-chevron-left"></i></button>',
    nextArrow: '<button class="review-slider-button slider--next flex-row"><i class="fa fa-chevron-right"></i></button>',
    responsive: [{
      breakpoint: 992,
      settings: {
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  };

  var $slider = void 0;
  var $sliderButtonsContainer = void 0;
  var $sliderButtons = void 0;
  var firstPause = false;

  var sliderInit = function sliderInit() {
    $slider.slick(sliderOptions);
  };

  var sliderPause = function sliderPause(index) {
    if (!firstPause) {
      $slider.slick('slickGoTo', index);
      $slider.slick('slickPause');
      firstPause = true;
    } else if ($slider.slick('slickCurrentSlide') === index) {
      $slider.slick('slickPlay');
    } else {
      $slider.slick('slickGoTo', index);
      $slider.slick('slickPause');
    }
  };

  var cacheDom = function cacheDom() {
    $slider = $('.vstroker-star-pick-slider');
    $sliderButtonsContainer = $('.vstroker-slider-selectors');
    $sliderButtons = $sliderButtonsContainer.find('.vstroker-slider-selector-name');
  };

  var bindUIActions = function bindUIActions() {
    $sliderButtons.on('click', function toggleClass() {
      var index = parseInt($(this).data('index'), 10);
      sliderPause(index);

      if ($(this).hasClass('vstroker-slider-selector-name-active')) {
        $sliderButtons.removeClass('vstroker-slider-selector-name-active');
      } else {
        $sliderButtons.removeClass('vstroker-slider-selector-name-active');
        $(this).addClass('vstroker-slider-selector-name-active');
      }
    });

    $slider.on('swipe', function swipePlay() {
      $sliderButtons.removeClass('vstroker-slider-selector-name-active');
      $(this).slick('slickPlay');
    });

    $sliderButtonsContainer.on('mouseenter', function () {
      $slider.slick('slickPause');
    });

    $sliderButtonsContainer.on('mouseleave', function () {
      if (!$sliderButtons.hasClass('vstroker-slider-selector-name-active')) {
        $slider.slick('slickPlay');
      }
    });
  };

  var init = function init() {
    cacheDom();
    sliderInit();
    bindUIActions();
  };

  VStroker.init = init;
})(window.VStroker = window.VStroker || {}, jQuery);